// src/data/data.js

// Maps user IDs to their best predictions (question IDs)
export const userBestPredictionsMap = {
    xJwcuYeWSLgbOg6utongRBPy8s03: [1, 2, 3], // Husain Gadiwala's best predictions
    o7PRyP0JfLPZMckV97g4dMeypp03: [4, 1, 5], // Brendan Machell's best predictions
    HKSZAa6kFBPc5W0iuSPOO6qrECj1: [2, 3, 5], // Finlay Johnman's best predictions
    LZfDcvvLbxfjIby3Rcd6DNhiOPI3: [3, 4, 1], // Irene G's best predictions
    // Add more mappings as needed
};

// Maps user IDs to their worst predictions (question IDs)
export const userWorstPredictionsMap = {
    xJwcuYeWSLgbOg6utongRBPy8s03: [4, 5, 6], // Husain Gadiwala's worst predictions
    o7PRyP0JfLPZMckV97g4dMeypp03: [2, 3, 6], // Brendan Machell's worst predictions
    HKSZAa6kFBPc5W0iuSPOO6qrECj1: [1, 4, 6], // Finlay Johnman's worst predictions
    LZfDcvvLbxfjIby3Rcd6DNhiOPI3: [2, 5, 6], // Irene G's worst predictions
    // Add more mappings as needed
};
export const questions = [
    {
        "id": 1,
        "title": "The UK Prime Minister did not hold a snap general election before June 1st.",
        "text": "The UK Prime Minister will hold a snap general election before June 1st.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 42.48,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 2,
        "title": "A fringe party did win more than 5% of the popular vote the general election.",
        "text": "A UK political party other than The Conservative Party, The Labour Party, Liberal Democrats or SNP will win more than 5% of the popular vote in the next general election.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 47.44,
        "occurred": true,
        "category": "UK Politics"
    },
    {
        "id": 3,
        "title": "The Conservative party did not win the General Election.",
        "text": "The Conservative party will win the next General Election.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 23.3,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 4,
        "title": "The Conservative party did undergo a change in leadership.",
        "text": "The Conservative party will undergo a change in leadership.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 72.25,
        "occurred": true,
        "category": "UK Politics"
    },
    {
        "id": 5,
        "title": "The Labour party did not undergo a change in leadership.",
        "text": "The Labour party will undergo a change in leadership.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 24.3,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 6,
        "title": "The Scottish Parliament did not pass a bill calling for a referendum on Scottish independence.",
        "text": "The Scottish Parliament will pass a bill calling for a new referendum on Scottish independence.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 33.41,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 7,
        "title": "The Northern Irish Parliament did not pass a bill calling for a referendum on joining the EU.",
        "text": "The Northern Irish Parliament will pass a bill calling for a new referendum on joining the EU.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 29.14,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 8,
        "title": "Jeremy Corbyn did not appear on the ballot for the London Mayoral election.",
        "text": "Jeremy Corbyn will appear on the ballot for the London Mayoral election.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 40.4,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 9,
        "title": "Sadiq Khan did win the London Mayoral election.",
        "text": "Sadiq Khan will win the next London Mayoral election.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 59.16,
        "occurred": true,
        "category": "UK Politics"
    },
    {
        "id": 10,
        "title": "The average UK house price did not exceed \u00a3300,000.",
        "text": "The average UK house price will exceed \u00a3300,000.",
        "summary": "This event was widely speculated in the media but did not occur.",
        "groupAverage": 50.54,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 11,
        "title": "The UK did not enter a recession.",
        "text": "The UK will enter a recession, as reported by the BBC.",
        "summary": "",
        "groupAverage": 57.25,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 12,
        "title": "The UK's annual inflation rate did drop below 3%.",
        "text": "The UK's annual inflation rate will drop below 3%, as reported on by the ONS.",
        "summary": "",
        "groupAverage": 50.37,
        "occurred": true,
        "category": "UK Politics"
    },
    {
        "id": 13,
        "title": "A general strike did not take place in the UK.",
        "text": "A general strike will take place in the UK, as reported on by the BBC.",
        "summary": "",
        "groupAverage": 35.22,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 14,
        "title": "The UK Government did pass legislation banning the sale of single-use (disposable) vapes.",
        "text": "The UK Government will pass legislation banning the sale of single-use (disposable) vapes.",
        "summary": "",
        "groupAverage": 61.21,
        "occurred": true,
        "category": "UK Politics"
    },
    {
        "id": 15,
        "title": "A sovereign state did not declare independence from the British monarchy.",
        "text": "A sovereign state will declare independence from the British monarchy.",
        "summary": "",
        "groupAverage": 40.92,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 16,
        "title": "The ONS did not report an increase in the number of people working fully remote jobs.",
        "text": "The ONS will report an increase in the number of people working fully remote jobs.",
        "summary": "",
        "groupAverage": 57.52,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 17,
        "title": "The UK Government did not transport a group of asylum seekers from the UK to Rwanda.",
        "text": "The UK Government will transport a group of asylum seekers from the UK to Rwanda.",
        "summary": "",
        "groupAverage": 38.3,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 18,
        "title": "The UK Government did not announce that it will return the Elgin Marbles to Greece.",
        "text": "The UK Government will formally announce that it will return the Elgin Marbles to Greece, as confirmed by the BBC.",
        "summary": "",
        "groupAverage": 30.59,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 19,
        "title": "The percentage of electricity derived from renewable sources did not rise above 55% in the UK for any quarter.",
        "text": "The percentage of electricity derived from renewable sources will rise above 55% in the UK for any quarter, as reported by gov.uk. ",
        "summary": "",
        "groupAverage": 48.71,
        "occurred": false,
        "category": "UK Politics"
    },
    {
        "id": 20,
        "title": "Donald Trump did win the Republican nomination for the 2024 Presidential election.",
        "text": "Donald Trump will win the Republican nomination for the 2024 Presidential election.",
        "summary": "",
        "groupAverage": 64.75,
        "occurred": true,
        "category": "Geopolitics"
    },
    {
        "id": 21,
        "title": "Joe Biden did not win the Democratic nomination for the 2024 Presidential election.",
        "text": "Joe Biden will win the Democratic nomination for the 2024 Presidential election.",
        "summary": "",
        "groupAverage": 63.4,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 22,
        "title": "The Republican Party did win the 2024 US presidential election.",
        "text": "The Republican Party will win the 2024 US presidential election.",
        "summary": "",
        "groupAverage": 56.76,
        "occurred": true,
        "category": "Geopolitics"
    },
    {
        "id": 23,
        "title": "Narendra Modi did continue as the Prime Minister of India following the 2024 Indian General Election.",
        "text": "Narendra Modi will continue as the Prime Minister of India following the 2024 Indian General Election.",
        "summary": "",
        "groupAverage": 76.44,
        "occurred": true,
        "category": "Geopolitics"
    },
    {
        "id": 24,
        "title": "Benjamin Netanyahu did not cease to be the Prime Minister of Israel",
        "text": "Benjamin Netanyahu will cease to be the Prime Minister of Israel.",
        "summary": "",
        "groupAverage": 41.38,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 25,
        "title": "Vladimir Putin did not cease to be the President of Russia.",
        "text": "Vladimir Putin will cease to be the President of Russia.",
        "summary": "",
        "groupAverage": 13.17,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 26,
        "title": "Xi Jinping did not cease to be the President of the People's Republic of China.",
        "text": "Xi Jinping will cease to be the President of the People's Republic of China.",
        "summary": "",
        "groupAverage": 12.51,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 27,
        "title": "There was not a lasting ceasefire between Russia and Ukraine.",
        "text": "There will be a lasting ceasefire between Russia and Ukraine, as acknowledged by both sides. ",
        "summary": "",
        "groupAverage": 37.59,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 28,
        "title": "The US or UK did not publicly announce or acknowledge that had executed a military strike in Israel or Palestine.",
        "text": "The United States or UK will publicly announce or acknowledge that it has executed a military strike within the territory of Israel, Gaza Strip, Golan Heights, or the West Bank.",
        "summary": "",
        "groupAverage": 25.87,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 29,
        "title": "IDF ground forces did not withdraw from the Gaza Strip.",
        "text": "Israel will publicly announce or acknowledge that IDF (Israel Defence Forces) ground forces have completely withdrawn from the Gaza Strip, as confirmed by an official statement from the Israeli government or the IDF.",
        "summary": "",
        "groupAverage": 34.21,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 30,
        "title": "There was not a lethal confrontation between India and China.",
        "text": "There will be a lethal confrontation between the national military forces of India and China as confirmed by an official statement from the government of India or China.",
        "summary": "",
        "groupAverage": 27.65,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 31,
        "title": "There was not a lethal confrontation between China and Taiwan.",
        "text": "There will be a lethal confrontation between China and Taiwan as confirmed by an official statement from the government of Taiwan or China.",
        "summary": "",
        "groupAverage": 40.75,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 32,
        "title": "A nuclear weapon was not deployed into Ukrainian territory.",
        "text": "The Russian or Belarusian government will publicly announce the deployment of one or more nuclear weapons into Ukrainian territory, as confirmed by an official government statement from Russia or Belarus.",
        "summary": "",
        "groupAverage": 23.56,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 33,
        "title": "The United Nations Security Council did not expand to include an additional permanent member.",
        "text": "The United Nations Security Council will expand to include an additional permanent member. ",
        "summary": "",
        "groupAverage": 37.35,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 34,
        "title": "A new country was not admitted as a full member of the European Union.",
        "text": "A new country will be admitted as a full member of the European Union.",
        "summary": "",
        "groupAverage": 42.14,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 35,
        "title": "NATO did admit a new country as a member.",
        "text": "NATO will admit a new country or part of a country as a member.",
        "summary": "",
        "groupAverage": 54.86,
        "occurred": true,
        "category": "Geopolitics"
    },
    {
        "id": 36,
        "title": "The World Health Organisation did declare a global health emergency due to an infectious disease outbreak.",
        "text": "The World Health Organisation will declare a new global health emergency due to an infectious disease outbreak.",
        "summary": "",
        "groupAverage": 29.3,
        "occurred": true,
        "category": "Geopolitics"
    },
    {
        "id": 37,
        "title": "Argentina did not reduce its annual inflation rate to below 50%.",
        "text": "Argentina will reduce its annual inflation rate to below 50%.",
        "summary": "",
        "groupAverage": 37.1,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 38,
        "title": "A P5 country did not officially announce their withdrawal from participation in COP 29.",
        "text": "A P5 country will officially announce their withdrawal from participation in COP 29, before the commencement of the conference.",
        "summary": "",
        "groupAverage": 41.44,
        "occurred": false,
        "category": "Geopolitics"
    },
    {
        "id": 39,
        "title": "Electric vehicle sales did account for more than 10% of total global car sales.",
        "text": "Electric vehicle sales will account for more than 10% of total global car sales.",
        "summary": "",
        "groupAverage": 69.1,
        "occurred": true,
        "category": "Geopolitics"
    },
    {
        "id": 40,
        "title": "The UK did not make it into the top 16 in the Eurovision song contest.",
        "text": "The UK won't make it into the top 16 in the Eurovision song contest.",
        "summary": "",
        "groupAverage": 59.05,
        "occurred": true,
        "category": "Popular Culture"
    },
    {
        "id": 41,
        "title": "Barbie did not win more Golden Globe awards than Oppenheimer.",
        "text": "Barbie will win more Golden Globe awards than Oppenheimer.",
        "summary": "",
        "groupAverage": 54.06,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 42,
        "title": "A non-English language film did not win the Academy Award for Best Picture at the Oscars.",
        "text": "A non-English language film will win the Academy Award for Best Picture at the Oscars.",
        "summary": "",
        "groupAverage": 29.08,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 43,
        "title": "A film did not break the record for the highest-grossing opening weekend in movie history worldwide.",
        "text": "A film will break the record for the highest-grossing opening weekend in movie history worldwide, surpassing the current record as reported by Box Office Mojo.",
        "summary": "",
        "groupAverage": 23.3,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 44,
        "title": "A television series did not break the record for the most-viewed season on Netflix.",
        "text": "A television series will break the record for the most-viewed season, as reported by Netflix's official press statements.",
        "summary": "",
        "groupAverage": 49.71,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 45,
        "title": "Marvel Studios did not gross an average revenue higher than \u00a3802m per film.",
        "text": "Marvel Studios will gross an average revenue higher than \u00a3802m per film.",
        "summary": "",
        "groupAverage": 34.25,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 46,
        "title": "A Marvel or DC superhero movie did receive a rating of above 90% on the Rotten Tomatoes as of December 31st.",
        "text": "A Marvel or DC superhero movie released after January 1st will receive a rating of above 90% on the Rotten Tomatoes as of December 31st. ",
        "summary": "",
        "groupAverage": 36.19,
        "occurred": true,
        "category": "Popular Culture"
    },
    {
        "id": 47,
        "title": "Oasis did officially announce a reunion.",
        "text": "Oasis will officially announce a reunion, either for a tour, a single performance, or a new music project.",
        "summary": "",
        "groupAverage": 35.06,
        "occurred": true,
        "category": "Popular Culture"
    },
    {
        "id": 48,
        "title": "Kanye West did not make a trip to Israel or Palestine.",
        "text": "Kanye West will make a publicly confirmed trip to either Israel or Palestine.",
        "summary": "",
        "groupAverage": 39.67,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 49,
        "title": "Travis Kelce and Taylor Swift did not get engaged.",
        "text": "Travis Kelce and Taylor Swift will announce or acknowledge that they are engaged to be married.",
        "summary": "",
        "groupAverage": 37.38,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 50,
        "title": "David Attenborough did not die",
        "text": "David Attenborough",
        "summary": "",
        "groupAverage": 49.3,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 51,
        "title": "Buzz Aldrin did not die",
        "text": "Buzz Aldrin",
        "summary": "",
        "groupAverage": 53.44,
        "occurred": false,
        "category": "Popular Culture"
    },
    {
        "id": 52,
        "title": "Clint Eastwood did not die",
        "text": "Clint Eastwood",
        "summary": "",
        "groupAverage": 48.83,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 53,
        "title": "Julie Andrews did not die",
        "text": "Julie Andrews",
        "summary": "",
        "groupAverage": 35.57,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 54,
        "title": "Paul McCartney did not die",
        "text": "Paul McCartney",
        "summary": "",
        "groupAverage": 21.97,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 55,
        "title": "Joe Biden did not die",
        "text": "Joe Biden",
        "summary": "",
        "groupAverage": 27.13,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 56,
        "title": "Charles III did not die",
        "text": "Charles III",
        "summary": "",
        "groupAverage": 16.98,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 57,
        "title": "Kanye West did not die",
        "text": "Kanye West",
        "summary": "",
        "groupAverage": 10.87,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 58,
        "title": "Pete Davidson did not die",
        "text": "Pete Davidson",
        "summary": "",
        "groupAverage": 11.19,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 59,
        "title": "Johnny Depp did not die",
        "text": "Johnny Depp",
        "summary": "",
        "groupAverage": 14.03,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 60,
        "title": "Britney Spears did not die",
        "text": "Britney Spears",
        "summary": "",
        "groupAverage": 12.52,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 61,
        "title": "Barack Obama did not die",
        "text": "Barack Obama",
        "summary": "",
        "groupAverage": 7.38,
        "occurred": false,
        "category": "Celebrity Deaths"
    },
    {
        "id": 62,
        "title": "The price of Bitcoin did exceed its previous all-time high of $68,789.63.",
        "text": "The price of Bitcoin will exceed its previous all-time high of $68,789.63.",
        "summary": "",
        "groupAverage": 26.83,
        "occurred": true,
        "category": "Business"
    },
    {
        "id": 63,
        "title": "A FAANG company did not report a quarterly loss in 2024.",
        "text": "A FAANG company will report a quarterly loss in 2024, as reported in their official quarterly financial statements.",
        "summary": "",
        "groupAverage": 52.41,
        "occurred": false,
        "category": "Business"
    },
    {
        "id": 64,
        "title": "A CEO of a FAANG company did not step down or get replaced.",
        "text": "A current CEO of a FAANG company will step down or be replaced, as confirmed by an official company announcement.",
        "summary": "",
        "groupAverage": 54.57,
        "occurred": false,
        "category": "Business"
    },
    {
        "id": 65,
        "title": "The England men's team did not win the 2024 Euros.",
        "text": "The England men's team will win the 2024 Euros.",
        "summary": "",
        "groupAverage": 35.78,
        "occurred": false,
        "category": "Sport"
    },
    {
        "id": 66,
        "title": "A UK side did not win the 2023/2024 men's Champions League.",
        "text": "A UK side will win the 2023/2024 men\u2019s Champions League.",
        "summary": "",
        "groupAverage": 48.63,
        "occurred": false,
        "category": "Sport"
    },
    {
        "id": 67,
        "title": "Manchester City did win the 2023/2024 men's Premier League.",
        "text": "Manchester City will win the 2023/2024 men\u2019s Premier League.",
        "summary": "",
        "groupAverage": 56.33,
        "occurred": true,
        "category": "Sport"
    },
    {
        "id": 68,
        "title": "An African or Asian country did win the 2024 Men's T20 Cricket World Cup.",
        "text": "An African or Asian country will win the 2024 Men's T20 Cricket World Cup.",
        "summary": "",
        "groupAverage": 57.62,
        "occurred": true,
        "category": "Sport"
    },
    {
        "id": 69,
        "title": "The 2024 Paris Summer Olympics did see a country win its first ever gold medal in any event.",
        "text": "The 2024 Paris Summer Olympics will see a country win its first ever gold medal in any event.",
        "summary": "",
        "groupAverage": 64.52,
        "occurred": true,
        "category": "Sport"
    },
    {
        "id": 70,
        "title": "Max Verstappen did win the Formula 1 Drivers' Championship for the 2024 season.",
        "text": "Max Verstappen will win the Formula 1 Drivers' Championship for the 2024 season.",
        "summary": "",
        "groupAverage": 79.65,
        "occurred": true,
        "category": "Sport"
    }
];


export const users = [
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "avatar": "https://via.placeholder.com/32"
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "avatar": "https://via.placeholder.com/32"
    }
];


export const userAnswers = {
    "UXqXDCWiC1N765apBOAiU98Bsuw2": {
        "1": 75,
        "2": 72,
        "3": 30,
        "4": 84,
        "5": 68,
        "6": 82,
        "7": 70,
        "8": 64,
        "9": 40,
        "10": 74,
        "11": 70,
        "12": 39,
        "13": 50,
        "14": 34,
        "15": 32,
        "16": 66,
        "17": 35,
        "18": 50,
        "19": 69,
        "20": 62,
        "21": 38,
        "22": 63,
        "23": 71,
        "24": 30,
        "25": 37,
        "26": 39,
        "27": 35,
        "28": 29,
        "29": 34,
        "30": 30,
        "31": 32,
        "32": 38,
        "33": 69,
        "34": 55,
        "35": 60,
        "36": 41,
        "37": 42,
        "38": 37,
        "39": 67,
        "40": 40,
        "41": 70,
        "42": 45,
        "43": 47,
        "44": 46,
        "45": 48,
        "46": 46,
        "47": 50,
        "48": 44,
        "49": 48,
        "50": 36,
        "51": 69,
        "52": 64,
        "53": 50,
        "54": 50,
        "55": 33,
        "56": 20,
        "57": 19,
        "58": 50,
        "59": 17,
        "60": 13,
        "61": 19,
        "62": 22,
        "63": 73,
        "64": 27,
        "65": 50,
        "66": 29,
        "67": 43,
        "68": 65,
        "69": 71,
        "70": 78
    },
    "Acs4tLZrDuck0cVsxRdqs3MySrr2": {
        "1": 5,
        "2": 10,
        "3": 29,
        "4": 60,
        "5": 20,
        "6": 20,
        "7": 10,
        "8": 20,
        "9": 70,
        "10": 70,
        "11": 70,
        "12": 20,
        "13": 70,
        "14": 90,
        "15": 20,
        "16": 70,
        "17": 70,
        "18": 19,
        "19": 30,
        "20": 20,
        "21": 30,
        "22": 20,
        "23": 61,
        "24": 20,
        "25": 20,
        "26": 20,
        "27": 20,
        "28": 20,
        "29": 20,
        "30": 10,
        "31": 30,
        "32": 4,
        "33": 20,
        "34": 20,
        "35": 10,
        "36": 11,
        "37": 15,
        "38": 5,
        "39": 26,
        "40": 60,
        "41": 20,
        "42": 90,
        "43": 10,
        "44": 25,
        "45": 20,
        "46": 10,
        "47": 5,
        "48": 40,
        "49": 60,
        "50": 30,
        "51": 20,
        "52": 10,
        "53": 2,
        "54": 20,
        "55": 60,
        "56": 10,
        "57": 40,
        "58": 15,
        "59": 5,
        "60": 10,
        "61": 0,
        "62": 10,
        "63": 61,
        "64": 61,
        "65": 30,
        "66": 65,
        "67": 40,
        "68": 86,
        "69": 80,
        "70": 60
    },
    "7ujgUeEmSRUJ1An7WFvVSLipyay1": {
        "1": 8,
        "2": 69,
        "3": 10,
        "4": 89,
        "5": 18,
        "6": 53,
        "7": 34,
        "8": 15,
        "9": 28,
        "10": 92,
        "11": 50,
        "12": 30,
        "13": 52,
        "14": 26,
        "15": 3,
        "16": 85,
        "17": 82,
        "18": 27,
        "19": 13,
        "20": 79,
        "21": 67,
        "22": 75,
        "23": 100,
        "24": 82,
        "25": 22,
        "26": 0,
        "27": 12,
        "28": 31,
        "29": 24,
        "30": 17,
        "31": 73,
        "32": 20,
        "33": 50,
        "34": 21,
        "35": 10,
        "36": 60,
        "37": 8,
        "38": 74,
        "39": 20,
        "40": 30,
        "41": 79,
        "42": 3,
        "43": 84,
        "44": 79,
        "45": 88,
        "46": 28,
        "47": 12,
        "48": 78,
        "49": 8,
        "50": 52,
        "51": 66,
        "52": 54,
        "53": 30,
        "54": 59,
        "55": 16,
        "56": 5,
        "57": 0,
        "58": 20,
        "59": 10,
        "60": 31,
        "61": 0,
        "62": 48,
        "63": 77,
        "64": 62,
        "65": 50,
        "66": 36,
        "67": 21,
        "68": 67,
        "69": 36,
        "70": 63
    },
    "dPICJRazi9Y6hgA0ZXrbQvfmKs53": {
        "1": 42,
        "2": 85,
        "3": 82,
        "4": 62,
        "5": 63,
        "6": 46,
        "7": 43,
        "8": 83,
        "9": 82,
        "10": 79,
        "11": 47,
        "12": 34,
        "13": 96,
        "14": 26,
        "15": 24,
        "16": 82,
        "17": 43,
        "18": 53,
        "19": 44,
        "20": 58,
        "21": 47,
        "22": 59,
        "23": 90,
        "24": 40,
        "25": 38,
        "26": 39,
        "27": 70,
        "28": 60,
        "29": 42,
        "30": 32,
        "31": 39,
        "32": 57,
        "33": 60,
        "34": 42,
        "35": 50,
        "36": 38,
        "37": 65,
        "38": 29,
        "39": 56,
        "40": 86,
        "41": 77,
        "42": 86,
        "43": 66,
        "44": 80,
        "45": 61,
        "46": 65,
        "47": 25,
        "48": 19,
        "49": 14,
        "50": 35,
        "51": 16,
        "52": 21,
        "53": 6,
        "54": 8,
        "55": 12,
        "56": 4,
        "57": 7,
        "58": 9,
        "59": 0,
        "60": 17,
        "61": 0,
        "62": 79,
        "63": 65,
        "64": 55,
        "65": 40,
        "66": 59,
        "67": 61,
        "68": 64,
        "69": 59,
        "70": 90
    },
    "XjBsTy3ScPcTAPDuY3R0rQggocl1": {
        "1": 10,
        "2": 10,
        "3": 18,
        "4": 65,
        "5": 24,
        "6": 20,
        "7": 20,
        "8": 5,
        "9": 40,
        "10": 40,
        "11": 30,
        "12": 60,
        "13": 1,
        "14": 70,
        "15": 40,
        "16": 60,
        "17": 20,
        "18": 0,
        "19": 40,
        "20": 80,
        "21": 100,
        "22": 75,
        "23": 95,
        "24": 20,
        "25": 0,
        "26": 0,
        "27": 15,
        "28": 10,
        "29": 25,
        "30": 0,
        "31": 0,
        "32": 0,
        "33": 0,
        "34": 60,
        "35": 10,
        "36": 10,
        "37": 60,
        "38": 5,
        "39": 81,
        "40": 90,
        "41": 80,
        "42": 3,
        "43": 2,
        "44": 2,
        "45": 9,
        "46": 20,
        "47": 5,
        "48": 40,
        "49": 70,
        "50": 20,
        "51": 25,
        "52": 10,
        "53": 25,
        "54": 10,
        "55": 5,
        "56": 5,
        "57": 2,
        "58": 0,
        "59": 1,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 25,
        "64": 40,
        "65": 35,
        "66": 60,
        "67": 75,
        "68": 40,
        "69": 70,
        "70": 95
    },
    "GpielrRtA4fNGRMp1z8kkTEsk6f1": {
        "1": 72,
        "2": 3,
        "3": 13,
        "4": 88,
        "5": 18,
        "6": 12,
        "7": 0,
        "8": 32,
        "9": 87,
        "10": 20,
        "11": 71,
        "12": 71,
        "13": 23,
        "14": 19,
        "15": 34,
        "16": 30,
        "17": 16,
        "18": 21,
        "19": 38,
        "20": 91,
        "21": 90,
        "22": 76,
        "23": 92,
        "24": 50,
        "25": 0,
        "26": 0,
        "27": 4,
        "28": 4,
        "29": 70,
        "30": 13,
        "31": 41,
        "32": 12,
        "33": 63,
        "34": 21,
        "35": 66,
        "36": 0,
        "37": 41,
        "38": 50,
        "39": 72,
        "40": 85,
        "41": 88,
        "42": 35,
        "43": 14,
        "44": 21,
        "45": 28,
        "46": 17,
        "47": 61,
        "48": 20,
        "49": 30,
        "50": 65,
        "51": 74,
        "52": 29,
        "53": 34,
        "54": 5,
        "55": 2,
        "56": 14,
        "57": 0,
        "58": 21,
        "59": 22,
        "60": 21,
        "61": 0,
        "62": 0,
        "63": 31,
        "64": 67,
        "65": 45,
        "66": 62,
        "67": 74,
        "68": 89,
        "69": 75,
        "70": 95
    },
    "Bu7e5p2Js6cfZgNxmK3hpmfENaG3": {
        "1": 87,
        "2": 82,
        "3": 50,
        "4": 100,
        "5": 89,
        "6": 36,
        "7": 59,
        "8": 37,
        "9": 39,
        "10": 50,
        "11": 80,
        "12": 31,
        "13": 50,
        "14": 70,
        "15": 100,
        "16": 70,
        "17": 0,
        "18": 88,
        "19": 78,
        "20": 50,
        "21": 50,
        "22": 50,
        "23": 50,
        "24": 79,
        "25": 66,
        "26": 33,
        "27": 77,
        "28": 68,
        "29": 91,
        "30": 25,
        "31": 34,
        "32": 16,
        "33": 70,
        "34": 34,
        "35": 66,
        "36": 73,
        "37": 15,
        "38": 11,
        "39": 67,
        "40": 83,
        "41": 30,
        "42": 11,
        "43": 20,
        "44": 11,
        "45": 18,
        "46": 17,
        "47": 74,
        "48": 76,
        "49": 83,
        "50": 100,
        "51": 100,
        "52": 66,
        "53": 29,
        "54": 75,
        "55": 79,
        "56": 84,
        "57": 28,
        "58": 22,
        "59": 70,
        "60": 0,
        "61": 25,
        "62": 6,
        "63": 59,
        "64": 60,
        "65": 100,
        "66": 35,
        "67": 32,
        "68": 73,
        "69": 100,
        "70": 77
    },
    "FirOjWicXtVT03na6xfo9XtwdLv1": {
        "1": 0,
        "2": 18,
        "3": 4,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 21,
        "8": 25,
        "9": 92,
        "10": 66,
        "11": 66,
        "12": 11,
        "13": 97,
        "14": 36,
        "15": 36,
        "16": 67,
        "17": 68,
        "18": 10,
        "19": 75,
        "20": 70,
        "21": 20,
        "22": 90,
        "23": 53,
        "24": 16,
        "25": 0,
        "26": 0,
        "27": 63,
        "28": 75,
        "29": 15,
        "30": 3,
        "31": 50,
        "32": 14,
        "33": 50,
        "34": 50,
        "35": 71,
        "36": 0,
        "37": 74,
        "38": 30,
        "39": 76,
        "40": 12,
        "41": 67,
        "42": 0,
        "43": 0,
        "44": 100,
        "45": 9,
        "46": 70,
        "47": 100,
        "48": 0,
        "49": 73,
        "50": 0,
        "51": 0,
        "52": 26,
        "53": 11,
        "54": 0,
        "55": 26,
        "56": 25,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 100,
        "63": 34,
        "64": 70,
        "65": 79,
        "66": 40,
        "67": 39,
        "68": 75,
        "69": 100,
        "70": 100
    },
    "wT6zaTJmoGRiWYIjpnFwmmI4a1r2": {
        "1": 39,
        "2": 56,
        "3": 33,
        "4": 66,
        "5": 41,
        "6": 61,
        "7": 60,
        "8": 70,
        "9": 50,
        "10": 65,
        "11": 43,
        "12": 43,
        "13": 67,
        "14": 61,
        "15": 68,
        "16": 74,
        "17": 50,
        "18": 50,
        "19": 63,
        "20": 97,
        "21": 100,
        "22": 80,
        "23": 81,
        "24": 50,
        "25": 28,
        "26": 28,
        "27": 50,
        "28": 42,
        "29": 56,
        "30": 41,
        "31": 50,
        "32": 56,
        "33": 50,
        "34": 36,
        "35": 38,
        "36": 36,
        "37": 20,
        "38": 67,
        "39": 69,
        "40": 27,
        "41": 80,
        "42": 32,
        "43": 9,
        "44": 10,
        "45": 53,
        "46": 64,
        "47": 34,
        "48": 72,
        "49": 64,
        "50": 80,
        "51": 78,
        "52": 59,
        "53": 31,
        "54": 5,
        "55": 37,
        "56": 1,
        "57": 11,
        "58": 11,
        "59": 13,
        "60": 3,
        "61": 4,
        "62": 26,
        "63": 61,
        "64": 68,
        "65": 37,
        "66": 52,
        "67": 53,
        "68": 50,
        "69": 72,
        "70": 60
    },
    "PipOhupErIUd4EXbvv5lEMTBZF62": {
        "1": 89,
        "2": 25,
        "3": 20,
        "4": 85,
        "5": 25,
        "6": 5,
        "7": 5,
        "8": 35,
        "9": 60,
        "10": 75,
        "11": 10,
        "12": 25,
        "13": 0,
        "14": 35,
        "15": 25,
        "16": 30,
        "17": 20,
        "18": 20,
        "19": 30,
        "20": 15,
        "21": 80,
        "22": 15,
        "23": 90,
        "24": 75,
        "25": 15,
        "26": 10,
        "27": 30,
        "28": 30,
        "29": 65,
        "30": 35,
        "31": 74,
        "32": 30,
        "33": 20,
        "34": 25,
        "35": 70,
        "36": 25,
        "37": 20,
        "38": 30,
        "39": 35,
        "40": 19,
        "41": 81,
        "42": 30,
        "43": 25,
        "44": 20,
        "45": 25,
        "46": 20,
        "47": 20,
        "48": 10,
        "49": 73,
        "50": 100,
        "51": 100,
        "52": 100,
        "53": 100,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 25,
        "63": 15,
        "64": 15,
        "65": 21,
        "66": 20,
        "67": 80,
        "68": 70,
        "69": 15,
        "70": 25
    },
    "DF8FSYwVgoTGdVDrAzEzQOON6ev2": {
        "1": 11,
        "2": 64,
        "3": 25,
        "4": 95,
        "5": 30,
        "6": 80,
        "7": 24,
        "8": 66,
        "9": 85,
        "10": 100,
        "11": 79,
        "12": 68,
        "13": 100,
        "14": 75,
        "15": 44,
        "16": 26,
        "17": 20,
        "18": 19,
        "19": 37,
        "20": 73,
        "21": 60,
        "22": 50,
        "23": 70,
        "24": 61,
        "25": 3,
        "26": 14,
        "27": 31,
        "28": 20,
        "29": 30,
        "30": 30,
        "31": 73,
        "32": 26,
        "33": 70,
        "34": 64,
        "35": 40,
        "36": 30,
        "37": 58,
        "38": 56,
        "39": 100,
        "40": 16,
        "41": 83,
        "42": 2,
        "43": 0,
        "44": 76,
        "45": 24,
        "46": 44,
        "47": 15,
        "48": 72,
        "49": 23,
        "50": 42,
        "51": 65,
        "52": 25,
        "53": 31,
        "54": 25,
        "55": 58,
        "56": 20,
        "57": 18,
        "58": 6,
        "59": 40,
        "60": 7,
        "61": 0,
        "62": 41,
        "63": 56,
        "64": 28,
        "65": 72,
        "66": 70,
        "67": 82,
        "68": 73,
        "69": 77,
        "70": 92
    },
    "9wYunIQxfLhkqZrIYPz9PJp6O5g1": {
        "1": 20,
        "2": 12,
        "3": 35,
        "4": 37,
        "5": 50,
        "6": 30,
        "7": 38,
        "8": 50,
        "9": 53,
        "10": 50,
        "11": 60,
        "12": 60,
        "13": 50,
        "14": 50,
        "15": 55,
        "16": 50,
        "17": 40,
        "18": 34,
        "19": 59,
        "20": 85,
        "21": 85,
        "22": 45,
        "23": 84,
        "24": 55,
        "25": 15,
        "26": 20,
        "27": 39,
        "28": 25,
        "29": 34,
        "30": 40,
        "31": 40,
        "32": 25,
        "33": 23,
        "34": 40,
        "35": 66,
        "36": 60,
        "37": 0,
        "38": 18,
        "39": 52,
        "40": 40,
        "41": 30,
        "42": 21,
        "43": 40,
        "44": 35,
        "45": 50,
        "46": 39,
        "47": 50,
        "48": 55,
        "49": 36,
        "50": 55,
        "51": 55,
        "52": 56,
        "53": 54,
        "54": 40,
        "55": 35,
        "56": 25,
        "57": 16,
        "58": 11,
        "59": 10,
        "60": 17,
        "61": 8,
        "62": 32,
        "63": 51,
        "64": 60,
        "65": 10,
        "66": 45,
        "67": 35,
        "68": 55,
        "69": 60,
        "70": 88
    },
    "6QAZqsUec6XRA4XYvclmTGVL4Bg1": {
        "1": 100,
        "2": 67,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 25,
        "9": 25,
        "10": 100,
        "11": 77,
        "12": 76,
        "13": 0,
        "14": 93,
        "15": 100,
        "16": 100,
        "17": 0,
        "18": 0,
        "19": 17,
        "20": 89,
        "21": 98,
        "22": 85,
        "23": 100,
        "24": 0,
        "25": 0,
        "26": 0,
        "27": 0,
        "28": 0,
        "29": 0,
        "30": 0,
        "31": 100,
        "32": 0,
        "33": 100,
        "34": 100,
        "35": 0,
        "36": 100,
        "37": 0,
        "38": 0,
        "39": 100,
        "40": 0,
        "41": 100,
        "42": 0,
        "43": 0,
        "44": 77,
        "45": 0,
        "46": 0,
        "47": 0,
        "48": 100,
        "49": 0,
        "50": 0,
        "51": 0,
        "52": 100,
        "53": 0,
        "54": 0,
        "55": 100,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 100,
        "64": 100,
        "65": 0,
        "66": 0,
        "67": 100,
        "68": 100,
        "69": 100,
        "70": 100
    },
    "yU2lJuRqrJXnK01IyEEFCrwd7cF3": {
        "1": 50,
        "2": 10,
        "3": 20,
        "4": 25,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 60,
        "10": 10,
        "11": 5,
        "12": 40,
        "13": 0,
        "14": 0,
        "15": 5,
        "16": 50,
        "17": 0,
        "18": 0,
        "19": 80,
        "20": 90,
        "21": 95,
        "22": 77,
        "23": 85,
        "24": 5,
        "25": 10,
        "26": 0,
        "27": 0,
        "28": 5,
        "29": 5,
        "30": 0,
        "31": 0,
        "32": 5,
        "33": 0,
        "34": 0,
        "35": 60,
        "36": 15,
        "37": 25,
        "38": 5,
        "39": 80,
        "40": 70,
        "41": 70,
        "42": 1,
        "43": 3,
        "44": 15,
        "45": 15,
        "46": 16,
        "47": 0,
        "48": 0,
        "49": 5,
        "50": 0,
        "51": 0,
        "52": 0,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 20,
        "63": 10,
        "64": 10,
        "65": 20,
        "66": 60,
        "67": 75,
        "68": 40,
        "69": 70,
        "70": 90
    },
    "Yk751oqQ7yUplHTeWNQ0b84mJ6l2": {
        "1": 0,
        "2": 100,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 100,
        "10": 0,
        "11": 0,
        "12": 12,
        "13": 0,
        "14": 78,
        "15": 25,
        "16": 89,
        "17": 20,
        "18": 0,
        "19": 21,
        "20": 80,
        "21": 80,
        "22": 83,
        "23": 75,
        "24": 13,
        "25": 0,
        "26": 0,
        "27": 19,
        "28": 14,
        "29": 0,
        "30": 30,
        "31": 18,
        "32": 18,
        "33": 12,
        "34": 20,
        "35": 65,
        "36": 0,
        "37": 18,
        "38": 37,
        "39": 35,
        "40": 72,
        "41": 0,
        "42": 35,
        "43": 0,
        "44": 74,
        "45": 10,
        "46": 0,
        "47": 30,
        "48": 0,
        "49": 30,
        "50": 0,
        "51": 0,
        "52": 0,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 0,
        "64": 22,
        "65": 5,
        "66": 73,
        "67": 16,
        "68": 28,
        "69": 34,
        "70": 100
    },
    "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2": {
        "1": 0,
        "2": 40,
        "3": 66,
        "4": 30,
        "5": 0,
        "6": 0,
        "7": 10,
        "8": 10,
        "9": 5,
        "10": 0,
        "11": 15,
        "12": 25,
        "13": 0,
        "14": 25,
        "15": 5,
        "16": 30,
        "17": 15,
        "18": 0,
        "19": 33,
        "20": 95,
        "21": 75,
        "22": 100,
        "23": 100,
        "24": 0,
        "25": 0,
        "26": 75,
        "27": 55,
        "28": 5,
        "29": 70,
        "30": 5,
        "31": 25,
        "32": 9,
        "33": 25,
        "34": 33,
        "35": 55,
        "36": 50,
        "37": 20,
        "38": 30,
        "39": 10,
        "40": 100,
        "41": 22,
        "42": 10,
        "43": 0,
        "44": 15,
        "45": 5,
        "46": 0,
        "47": 0,
        "48": 15,
        "49": 55,
        "50": 0,
        "51": 66,
        "52": 33,
        "53": 39,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 20,
        "58": 0,
        "59": 26,
        "60": 30,
        "61": 0,
        "62": 10,
        "63": 36,
        "64": 5,
        "65": 5,
        "66": 20,
        "67": 100,
        "68": 63,
        "69": 39,
        "70": 100
    },
    "o7PRyP0JfLPZMckV97g4dMeypp03": {
        "1": 0,
        "2": 100,
        "3": 0,
        "4": 100,
        "5": 9,
        "6": 63,
        "7": 62,
        "8": 0,
        "9": 100,
        "10": 100,
        "11": 79,
        "12": 0,
        "13": 0,
        "14": 85,
        "15": 67,
        "16": 33,
        "17": 0,
        "18": 17,
        "19": 79,
        "20": 100,
        "21": 100,
        "22": 100,
        "23": 100,
        "24": 18,
        "25": 9,
        "26": 0,
        "27": 18,
        "28": 0,
        "29": 20,
        "30": 21,
        "31": 60,
        "32": 15,
        "33": 14,
        "34": 78,
        "35": 80,
        "36": 0,
        "37": 0,
        "38": 24,
        "39": 79,
        "40": 100,
        "41": 0,
        "42": 0,
        "43": 75,
        "44": 100,
        "45": 70,
        "46": 100,
        "47": 100,
        "48": 23,
        "49": 10,
        "50": 100,
        "51": 80,
        "52": 100,
        "53": 76,
        "54": 0,
        "55": 20,
        "56": 16,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 20,
        "63": 85,
        "64": 86,
        "65": 0,
        "66": 90,
        "67": 100,
        "68": 0,
        "69": 67,
        "70": 79
    },
    "TSxgE4BLbKMvgHKcI2u6mzY13rB2": {
        "1": 28,
        "2": 28,
        "3": 42,
        "4": 69,
        "5": 37,
        "6": 12,
        "7": 50,
        "8": 0,
        "9": 63,
        "10": 65,
        "11": 57,
        "12": 30,
        "13": 43,
        "14": 62,
        "15": 60,
        "16": 77,
        "17": 24,
        "18": 32,
        "19": 65,
        "20": 0,
        "21": 100,
        "22": 50,
        "23": 46,
        "24": 50,
        "25": 0,
        "26": 0,
        "27": 66,
        "28": 0,
        "29": 0,
        "30": 49,
        "31": 44,
        "32": 31,
        "33": 64,
        "34": 26,
        "35": 60,
        "36": 36,
        "37": 0,
        "38": 40,
        "39": 100,
        "40": 100,
        "41": 0,
        "42": 0,
        "43": 35,
        "44": 69,
        "45": 30,
        "46": 30,
        "47": 0,
        "48": 0,
        "49": 0,
        "50": 72,
        "51": 73,
        "52": 70,
        "53": 69,
        "54": 27,
        "55": 12,
        "56": 40,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 36,
        "63": 59,
        "64": 50,
        "65": 21,
        "66": 34,
        "67": 16,
        "68": 44,
        "69": 72,
        "70": 97
    },
    "Abe28w8a15VMFspqIxTKBZ7mWrQ2": {
        "1": 100,
        "2": 95,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 14,
        "7": 18,
        "8": 16,
        "9": 78,
        "10": 10,
        "11": 34,
        "12": 69,
        "13": 0,
        "14": 89,
        "15": 100,
        "16": 18,
        "17": 0,
        "18": 100,
        "19": 40,
        "20": 71,
        "21": 35,
        "22": 35,
        "23": 100,
        "24": 26,
        "25": 0,
        "26": 0,
        "27": 25,
        "28": 0,
        "29": 1,
        "30": 0,
        "31": 36,
        "32": 73,
        "33": 72,
        "34": 44,
        "35": 41,
        "36": 82,
        "37": 29,
        "38": 76,
        "39": 70,
        "40": 15,
        "41": 79,
        "42": 14,
        "43": 33,
        "44": 79,
        "45": 37,
        "46": 15,
        "47": 92,
        "48": 83,
        "49": 25,
        "50": 81,
        "51": 85,
        "52": 85,
        "53": 27,
        "54": 27,
        "55": 29,
        "56": 26,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 65,
        "64": 70,
        "65": 13,
        "66": 77,
        "67": 73,
        "68": 86,
        "69": 33,
        "70": 86
    },
    "fMfO5eFMJeSXabpuvWBZZT2dOon1": {
        "1": 67,
        "2": 0,
        "3": 41,
        "4": 64,
        "5": 45,
        "6": 61,
        "7": 43,
        "8": 69,
        "9": 38,
        "10": 60,
        "11": 71,
        "12": 30,
        "13": 39,
        "14": 32,
        "15": 40,
        "16": 67,
        "17": 36,
        "18": 22,
        "19": 31,
        "20": 59,
        "21": 42,
        "22": 41,
        "23": 58,
        "24": 41,
        "25": 40,
        "26": 26,
        "27": 56,
        "28": 39,
        "29": 37,
        "30": 40,
        "31": 25,
        "32": 58,
        "33": 38,
        "34": 39,
        "35": 45,
        "36": 33,
        "37": 43,
        "38": 55,
        "39": 79,
        "40": 65,
        "41": 62,
        "42": 42,
        "43": 65,
        "44": 64,
        "45": 60,
        "46": 39,
        "47": 62,
        "48": 39,
        "49": 37,
        "50": 64,
        "51": 28,
        "52": 44,
        "53": 43,
        "54": 62,
        "55": 39,
        "56": 37,
        "57": 65,
        "58": 62,
        "59": 39,
        "60": 37,
        "61": 31,
        "62": 36,
        "63": 30,
        "64": 66,
        "65": 40,
        "66": 67,
        "67": 41,
        "68": 64,
        "69": 67,
        "70": 64
    },
    "SoxVY1kursSNm12FQRUAaUHK1TH2": {
        "1": 20,
        "2": 100,
        "3": 35,
        "4": 80,
        "5": 20,
        "6": 15,
        "7": 0,
        "8": 60,
        "9": 50,
        "10": 20,
        "11": 30,
        "12": 70,
        "13": 35,
        "14": 35,
        "15": 0,
        "16": 75,
        "17": 60,
        "18": 50,
        "19": 70,
        "20": 70,
        "21": 20,
        "22": 50,
        "23": 50,
        "24": 90,
        "25": 25,
        "26": 50,
        "27": 25,
        "28": 15,
        "29": 60,
        "30": 15,
        "31": 50,
        "32": 0,
        "33": 0,
        "34": 60,
        "35": 60,
        "36": 25,
        "37": 50,
        "38": 15,
        "39": 100,
        "40": 50,
        "41": 30,
        "42": 20,
        "43": 30,
        "44": 60,
        "45": 75,
        "46": 60,
        "47": 0,
        "48": 70,
        "49": 50,
        "50": 20,
        "51": 70,
        "52": 50,
        "53": 50,
        "54": 30,
        "55": 15,
        "56": 10,
        "57": 15,
        "58": 15,
        "59": 35,
        "60": 35,
        "61": 25,
        "62": 50,
        "63": 60,
        "64": 40,
        "65": 30,
        "66": 70,
        "67": 50,
        "68": 50,
        "69": 80,
        "70": 75
    },
    "j3kOHaodmkdIHTiiMFGUNAD9uZD2": {
        "1": 20,
        "2": 55,
        "3": 20,
        "4": 95,
        "5": 10,
        "6": 15,
        "7": 65,
        "8": 100,
        "9": 65,
        "10": 10,
        "11": 85,
        "12": 35,
        "13": 20,
        "14": 60,
        "15": 50,
        "16": 35,
        "17": 5,
        "18": 30,
        "19": 55,
        "20": 5,
        "21": 5,
        "22": 95,
        "23": 10,
        "24": 5,
        "25": 0,
        "26": 0,
        "27": 25,
        "28": 59,
        "29": 10,
        "30": 0,
        "31": 0,
        "32": 15,
        "33": 30,
        "34": 65,
        "35": 5,
        "36": 65,
        "37": 90,
        "38": 100,
        "39": 100,
        "40": 85,
        "41": 85,
        "42": 70,
        "43": 5,
        "44": 20,
        "45": 68,
        "46": 70,
        "47": 0,
        "48": 100,
        "49": 70,
        "50": 100,
        "51": 20,
        "52": 80,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 16,
        "57": 1,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 42,
        "63": 0,
        "64": 36,
        "65": 54,
        "66": 50,
        "67": 30,
        "68": 66,
        "69": 25,
        "70": 100
    },
    "HFK2usr6XgawGCKdiq3RoYvJDnF3": {
        "1": 100,
        "2": 91,
        "3": 1,
        "4": 75,
        "5": 7,
        "6": 16,
        "7": 47,
        "8": 44,
        "9": 41,
        "10": 44,
        "11": 59,
        "12": 58,
        "13": 47,
        "14": 42,
        "15": 3,
        "16": 62,
        "17": 52,
        "18": 58,
        "19": 46,
        "20": 55,
        "21": 63,
        "22": 42,
        "23": 67,
        "24": 88,
        "25": 33,
        "26": 45,
        "27": 36,
        "28": 59,
        "29": 67,
        "30": 41,
        "31": 76,
        "32": 29,
        "33": 65,
        "34": 23,
        "35": 69,
        "36": 32,
        "37": 62,
        "38": 57,
        "39": 55,
        "40": 68,
        "41": 60,
        "42": 65,
        "43": 71,
        "44": 69,
        "45": 58,
        "46": 46,
        "47": 75,
        "48": 54,
        "49": 57,
        "50": 60,
        "51": 83,
        "52": 56,
        "53": 71,
        "54": 46,
        "55": 70,
        "56": 50,
        "57": 50,
        "58": 50,
        "59": 31,
        "60": 31,
        "61": 28,
        "62": 58,
        "63": 62,
        "64": 62,
        "65": 80,
        "66": 50,
        "67": 26,
        "68": 17,
        "69": 61,
        "70": 43
    },
    "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2": {
        "1": 0,
        "2": 67,
        "3": 32,
        "4": 100,
        "5": 66,
        "6": 36,
        "7": 35,
        "8": 75,
        "9": 82,
        "10": 81,
        "11": 100,
        "12": 82,
        "13": 37,
        "14": 100,
        "15": 40,
        "16": 100,
        "17": 61,
        "18": 23,
        "19": 34,
        "20": 0,
        "21": 72,
        "22": 0,
        "23": 100,
        "24": 36,
        "25": 0,
        "26": 0,
        "27": 61,
        "28": 0,
        "29": 0,
        "30": 100,
        "31": 40,
        "32": 0,
        "33": 24,
        "34": 100,
        "35": 100,
        "36": 0,
        "37": 64,
        "38": 23,
        "39": 40,
        "40": 19,
        "41": 100,
        "42": 26,
        "43": 0,
        "44": 100,
        "45": 72,
        "46": 100,
        "47": 0,
        "48": 100,
        "49": 33,
        "50": 86,
        "51": 100,
        "52": 73,
        "53": 82,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 32,
        "60": 0,
        "61": 16,
        "62": 0,
        "63": 87,
        "64": 25,
        "65": 17,
        "66": 64,
        "67": 79,
        "68": 81,
        "69": 73,
        "70": 92
    },
    "dvUtmCN2ucO8sHHV95JNN9adiCF2": {
        "1": 20,
        "2": 71,
        "3": 35,
        "4": 45,
        "5": 45,
        "6": 50,
        "7": 50,
        "8": 25,
        "9": 30,
        "10": 30,
        "11": 40,
        "12": 70,
        "13": 51,
        "14": 62,
        "15": 20,
        "16": 50,
        "17": 61,
        "18": 56,
        "19": 59,
        "20": 65,
        "21": 40,
        "22": 52,
        "23": 58,
        "24": 41,
        "25": 36,
        "26": 38,
        "27": 45,
        "28": 20,
        "29": 69,
        "30": 50,
        "31": 65,
        "32": 64,
        "33": 70,
        "34": 72,
        "35": 63,
        "36": 15,
        "37": 50,
        "38": 58,
        "39": 43,
        "40": 50,
        "41": 43,
        "42": 40,
        "43": 40,
        "44": 41,
        "45": 57,
        "46": 53,
        "47": 10,
        "48": 32,
        "49": 50,
        "50": 45,
        "51": 52,
        "52": 41,
        "53": 50,
        "54": 10,
        "55": 17,
        "56": 11,
        "57": 50,
        "58": 24,
        "59": 16,
        "60": 25,
        "61": 16,
        "62": 95,
        "63": 44,
        "64": 40,
        "65": 52,
        "66": 64,
        "67": 68,
        "68": 45,
        "69": 42,
        "70": 68
    },
    "kd0Oz58aWnfHpMWbCuUT5zMgCvH3": {
        "1": 15,
        "2": 80,
        "3": 25,
        "4": 60,
        "5": 35,
        "6": 40,
        "7": 35,
        "8": 25,
        "9": 70,
        "10": 30,
        "11": 60,
        "12": 20,
        "13": 80,
        "14": 100,
        "15": 20,
        "16": 75,
        "17": 90,
        "18": 65,
        "19": 65,
        "20": 35,
        "21": 65,
        "22": 35,
        "23": 65,
        "24": 35,
        "25": 15,
        "26": 10,
        "27": 35,
        "28": 35,
        "29": 25,
        "30": 35,
        "31": 40,
        "32": 60,
        "33": 10,
        "34": 5,
        "35": 65,
        "36": 55,
        "37": 30,
        "38": 55,
        "39": 70,
        "40": 25,
        "41": 75,
        "42": 5,
        "43": 60,
        "44": 85,
        "45": 35,
        "46": 40,
        "47": 75,
        "48": 35,
        "49": 40,
        "50": 40,
        "51": 60,
        "52": 70,
        "53": 40,
        "54": 30,
        "55": 15,
        "56": 10,
        "57": 5,
        "58": 5,
        "59": 5,
        "60": 15,
        "61": 2,
        "62": 20,
        "63": 70,
        "64": 65,
        "65": 30,
        "66": 35,
        "67": 75,
        "68": 35,
        "69": 65,
        "70": 85
    },
    "DsYhVWUpjagCXjk79kwv4uQFQcK2": {
        "1": 33,
        "2": 65,
        "3": 6,
        "4": 95,
        "5": 1,
        "6": 10,
        "7": 20,
        "8": 10,
        "9": 51,
        "10": 80,
        "11": 35,
        "12": 65,
        "13": 3,
        "14": 80,
        "15": 65,
        "16": 38,
        "17": 78,
        "18": 20,
        "19": 33,
        "20": 36,
        "21": 72,
        "22": 63,
        "23": 81,
        "24": 71,
        "25": 2,
        "26": 0,
        "27": 18,
        "28": 0,
        "29": 9,
        "30": 8,
        "31": 6,
        "32": 15,
        "33": 14,
        "34": 65,
        "35": 8,
        "36": 16,
        "37": 69,
        "38": 10,
        "39": 76,
        "40": 33,
        "41": 56,
        "42": 30,
        "43": 29,
        "44": 58,
        "45": 38,
        "46": 40,
        "47": 40,
        "48": 53,
        "49": 40,
        "50": 36,
        "51": 31,
        "52": 32,
        "53": 32,
        "54": 30,
        "55": 31,
        "56": 11,
        "57": 20,
        "58": 18,
        "59": 32,
        "60": 24,
        "61": 15,
        "62": 61,
        "63": 49,
        "64": 57,
        "65": 35,
        "66": 57,
        "67": 76,
        "68": 49,
        "69": 78,
        "70": 64
    },
    "c4TgneTGQ8WD2El5dRGgb9NpIHR2": {
        "1": 65,
        "2": 30,
        "3": 70,
        "4": 90,
        "5": 50,
        "6": 75,
        "7": 70,
        "8": 40,
        "9": 65,
        "10": 45,
        "11": 40,
        "12": 55,
        "13": 85,
        "14": 70,
        "15": 35,
        "16": 70,
        "17": 30,
        "18": 60,
        "19": 50,
        "20": 80,
        "21": 30,
        "22": 80,
        "23": 50,
        "24": 60,
        "25": 0,
        "26": 30,
        "27": 55,
        "28": 60,
        "29": 55,
        "30": 30,
        "31": 30,
        "32": 65,
        "33": 40,
        "34": 30,
        "35": 30,
        "36": 55,
        "37": 40,
        "38": 60,
        "39": 65,
        "40": 40,
        "41": 70,
        "42": 20,
        "43": 45,
        "44": 60,
        "45": 65,
        "46": 60,
        "47": 50,
        "48": 25,
        "49": 0,
        "50": 60,
        "51": 50,
        "52": 60,
        "53": 55,
        "54": 60,
        "55": 70,
        "56": 70,
        "57": 30,
        "58": 40,
        "59": 30,
        "60": 60,
        "61": 0,
        "62": 65,
        "63": 41,
        "64": 70,
        "65": 0,
        "66": 50,
        "67": 50,
        "68": 55,
        "69": 70,
        "70": 100
    },
    "xJwcuYeWSLgbOg6utongRBPy8s03": {
        "1": 0,
        "2": 21,
        "3": 7,
        "4": 50,
        "5": 19,
        "6": 80,
        "7": 13,
        "8": 66,
        "9": 69,
        "10": 50,
        "11": 86,
        "12": 31,
        "13": 62,
        "14": 50,
        "15": 0,
        "16": 39,
        "17": 42,
        "18": 0,
        "19": 45,
        "20": 100,
        "21": 64,
        "22": 64,
        "23": 100,
        "24": 38,
        "25": 0,
        "26": 0,
        "27": 56,
        "28": 0,
        "29": 42,
        "30": 0,
        "31": 26,
        "32": 65,
        "33": 21,
        "34": 27,
        "35": 72,
        "36": 21,
        "37": 15,
        "38": 36,
        "39": 67,
        "40": 79,
        "41": 37,
        "42": 37,
        "43": 0,
        "44": 42,
        "45": 26,
        "46": 39,
        "47": 50,
        "48": 71,
        "49": 60,
        "50": 76,
        "51": 50,
        "52": 65,
        "53": 67,
        "54": 79,
        "55": 90,
        "56": 67,
        "57": 26,
        "58": 0,
        "59": 28,
        "60": 18,
        "61": 59,
        "62": 30,
        "63": 43,
        "64": 70,
        "65": 38,
        "66": 37,
        "67": 40,
        "68": 100,
        "69": 100,
        "70": 100
    },
    "BUJRLKGHyrWes2KF8KXAqjChrP83": {
        "1": 50,
        "2": 60,
        "3": 55,
        "4": 65,
        "5": 50,
        "6": 50,
        "7": 55,
        "8": 60,
        "9": 40,
        "10": 25,
        "11": 40,
        "12": 70,
        "13": 50,
        "14": 90,
        "15": 50,
        "16": 70,
        "17": 65,
        "18": 80,
        "19": 70,
        "20": 70,
        "21": 65,
        "22": 50,
        "23": 65,
        "24": 60,
        "25": 15,
        "26": 15,
        "27": 55,
        "28": 5,
        "29": 25,
        "30": 55,
        "31": 35,
        "32": 30,
        "33": 25,
        "34": 55,
        "35": 65,
        "36": 35,
        "37": 55,
        "38": 40,
        "39": 90,
        "40": 50,
        "41": 0,
        "42": 20,
        "43": 15,
        "44": 50,
        "45": 55,
        "46": 68,
        "47": 50,
        "48": 55,
        "49": 35,
        "50": 30,
        "51": 65,
        "52": 70,
        "53": 35,
        "54": 50,
        "55": 10,
        "56": 15,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 10,
        "63": 35,
        "64": 25,
        "65": 15,
        "66": 50,
        "67": 50,
        "68": 80,
        "69": 55,
        "70": 80
    },
    "rA5m4nqqDncLI3JYTKyXromZ8Jz2": {
        "1": 54,
        "2": 27,
        "3": 41,
        "4": 69,
        "5": 59,
        "6": 54,
        "7": 28,
        "8": 20,
        "9": 40,
        "10": 62,
        "11": 67,
        "12": 45,
        "13": 4,
        "14": 65,
        "15": 68,
        "16": 40,
        "17": 66,
        "18": 15,
        "19": 43,
        "20": 63,
        "21": 96,
        "22": 67,
        "23": 82,
        "24": 67,
        "25": 21,
        "26": 8,
        "27": 21,
        "28": 4,
        "29": 67,
        "30": 21,
        "31": 61,
        "32": 0,
        "33": 0,
        "34": 72,
        "35": 69,
        "36": 25,
        "37": 7,
        "38": 79,
        "39": 73,
        "40": 100,
        "41": 34,
        "42": 6,
        "43": 16,
        "44": 80,
        "45": 7,
        "46": 82,
        "47": 18,
        "48": 60,
        "49": 40,
        "50": 83,
        "51": 69,
        "52": 36,
        "53": 30,
        "54": 18,
        "55": 18,
        "56": 29,
        "57": 6,
        "58": 25,
        "59": 9,
        "60": 60,
        "61": 7,
        "62": 26,
        "63": 65,
        "64": 73,
        "65": 37,
        "66": 27,
        "67": 70,
        "68": 37,
        "69": 83,
        "70": 69
    },
    "HKSZAa6kFBPc5W0iuSPOO6qrECj1": {
        "1": 27,
        "2": 80,
        "3": 21,
        "4": 75,
        "5": 25,
        "6": 31,
        "7": 21,
        "8": 35,
        "9": 71,
        "10": 79,
        "11": 65,
        "12": 60,
        "13": 9,
        "14": 75,
        "15": 65,
        "16": 65,
        "17": 33,
        "18": 35,
        "19": 66,
        "20": 85,
        "21": 85,
        "22": 65,
        "23": 85,
        "24": 29,
        "25": 5,
        "26": 5,
        "27": 39,
        "28": 35,
        "29": 25,
        "30": 55,
        "31": 55,
        "32": 34,
        "33": 25,
        "34": 65,
        "35": 65,
        "36": 35,
        "37": 60,
        "38": 45,
        "39": 45,
        "40": 85,
        "41": 55,
        "42": 64,
        "43": 30,
        "44": 20,
        "45": 24,
        "46": 7,
        "47": 45,
        "48": 40,
        "49": 58,
        "50": 66,
        "51": 55,
        "52": 40,
        "53": 50,
        "54": 20,
        "55": 42,
        "56": 22,
        "57": 6,
        "58": 5,
        "59": 4,
        "60": 6,
        "61": 21,
        "62": 17,
        "63": 36,
        "64": 70,
        "65": 56,
        "66": 45,
        "67": 65,
        "68": 35,
        "69": 62,
        "70": 64
    },
    "MAag3gLAD5MFDkr4xiN8Pr5sTkm1": {
        "1": 100,
        "2": 100,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 100,
        "9": 0,
        "10": 0,
        "11": 100,
        "12": 100,
        "13": 0,
        "14": 100,
        "15": 100,
        "16": 100,
        "17": 0,
        "18": 0,
        "19": 100,
        "20": 100,
        "21": 100,
        "22": 100,
        "23": 100,
        "24": 100,
        "25": 0,
        "26": 0,
        "27": 100,
        "28": 0,
        "29": 0,
        "30": 0,
        "31": 100,
        "32": 0,
        "33": 0,
        "34": 100,
        "35": 100,
        "36": 0,
        "37": 100,
        "38": 100,
        "39": 100,
        "40": 100,
        "41": 100,
        "42": 0,
        "43": 0,
        "44": 100,
        "45": 0,
        "46": 100,
        "47": 0,
        "48": 100,
        "49": 100,
        "50": 0,
        "51": 100,
        "52": 100,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 100,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 100,
        "64": 100,
        "65": 100,
        "66": 0,
        "67": 100,
        "68": 100,
        "69": 100,
        "70": 100
    },
    "PLuztKYlXgb4UfBIhBlMXY6fIrJ3": {
        "1": 20,
        "2": 30,
        "3": 70,
        "4": 30,
        "5": 70,
        "6": 60,
        "7": 40,
        "8": 80,
        "9": 20,
        "10": 90,
        "11": 85,
        "12": 60,
        "13": 70,
        "14": 85,
        "15": 90,
        "16": 40,
        "17": 10,
        "18": 35,
        "19": 80,
        "20": 5,
        "21": 0,
        "22": 95,
        "23": 75,
        "24": 15,
        "25": 5,
        "26": 5,
        "27": 60,
        "28": 10,
        "29": 60,
        "30": 5,
        "31": 60,
        "32": 15,
        "33": 40,
        "34": 95,
        "35": 95,
        "36": 5,
        "37": 75,
        "38": 95,
        "39": 70,
        "40": 15,
        "41": 20,
        "42": 35,
        "43": 10,
        "44": 65,
        "45": 20,
        "46": 30,
        "47": 75,
        "48": 5,
        "49": 15,
        "50": 70,
        "51": 40,
        "52": 70,
        "53": 40,
        "54": 10,
        "55": 15,
        "56": 5,
        "57": 40,
        "58": 5,
        "59": 5,
        "60": 20,
        "61": 5,
        "62": 20,
        "63": 10,
        "64": 85,
        "65": 65,
        "66": 40,
        "67": 40,
        "68": 75,
        "69": 70,
        "70": 85
    },
    "5kFjlBp37DU3dL4YoJCCz2uAJNg1": {
        "1": 72,
        "2": 68,
        "3": 57,
        "4": 28,
        "5": 77,
        "6": 100,
        "7": 61,
        "8": 0,
        "9": 20,
        "10": 41,
        "11": 26,
        "12": 74,
        "13": 79,
        "14": 96,
        "15": 77,
        "16": 28,
        "17": 26,
        "18": 73,
        "19": 17,
        "20": 0,
        "21": 33,
        "22": 24,
        "23": 70,
        "24": 75,
        "25": 0,
        "26": 0,
        "27": 66,
        "28": 72,
        "29": 17,
        "30": 20,
        "31": 0,
        "32": 0,
        "33": 70,
        "34": 28,
        "35": 86,
        "36": 84,
        "37": 16,
        "38": 19,
        "39": 70,
        "40": 100,
        "41": 39,
        "42": 63,
        "43": 60,
        "44": 100,
        "45": 37,
        "46": 16,
        "47": 36,
        "48": 0,
        "49": 0,
        "50": 100,
        "51": 28,
        "52": 67,
        "53": 0,
        "54": 0,
        "55": 58,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 25,
        "60": 36,
        "61": 0,
        "62": 0,
        "63": 64,
        "64": 71,
        "65": 0,
        "66": 0,
        "67": 65,
        "68": 77,
        "69": 100,
        "70": 47
    },
    "UOLLINDsq3VV8Za6lZI5bHrWxOl1": {
        "1": 10,
        "2": 0,
        "3": 75,
        "4": 70,
        "5": 0,
        "6": 50,
        "7": 50,
        "8": 0,
        "9": 85,
        "10": 70,
        "11": 100,
        "12": 0,
        "13": 40,
        "14": 50,
        "15": 25,
        "16": 35,
        "17": 20,
        "18": 0,
        "19": 0,
        "20": 90,
        "21": 15,
        "22": 15,
        "23": 50,
        "24": 80,
        "25": 0,
        "26": 0,
        "27": 0,
        "28": 100,
        "29": 0,
        "30": 0,
        "31": 35,
        "32": 0,
        "33": 0,
        "34": 50,
        "35": 65,
        "36": 80,
        "37": 0,
        "38": 75,
        "39": 0,
        "40": 100,
        "41": 100,
        "42": 0,
        "43": 0,
        "44": 0,
        "45": 0,
        "46": 0,
        "47": 85,
        "48": 50,
        "49": 50,
        "50": 50,
        "51": 50,
        "52": 50,
        "53": 50,
        "54": 50,
        "55": 50,
        "56": 50,
        "57": 50,
        "58": 50,
        "59": 50,
        "60": 50,
        "61": 50,
        "62": 75,
        "63": 100,
        "64": 100,
        "65": 0,
        "66": 50,
        "67": 50,
        "68": 85,
        "69": 65,
        "70": 100
    },
    "5I2OYYJ0H4YaZbbN02p4JsECACq1": {
        "1": 0,
        "2": 76,
        "3": 0,
        "4": 85,
        "5": 0,
        "6": 0,
        "7": 24,
        "8": 67,
        "9": 88,
        "10": 20,
        "11": 45,
        "12": 80,
        "13": 0,
        "14": 21,
        "15": 15,
        "16": 67,
        "17": 33,
        "18": 0,
        "19": 20,
        "20": 100,
        "21": 90,
        "22": 82,
        "23": 79,
        "24": 20,
        "25": 11,
        "26": 0,
        "27": 10,
        "28": 0,
        "29": 0,
        "30": 20,
        "31": 11,
        "32": 0,
        "33": 0,
        "34": 0,
        "35": 70,
        "36": 21,
        "37": 15,
        "38": 24,
        "39": 76,
        "40": 0,
        "41": 0,
        "42": 10,
        "43": 15,
        "44": 21,
        "45": 10,
        "46": 20,
        "47": 10,
        "48": 15,
        "49": 14,
        "50": 20,
        "51": 20,
        "52": 21,
        "53": 15,
        "54": 15,
        "55": 10,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 10,
        "63": 82,
        "64": 50,
        "65": 75,
        "66": 67,
        "67": 60,
        "68": 82,
        "69": 50,
        "70": 91
    },
    "kND9A5zVGLMWYUinkSdHx1v3eS53": {
        "1": 25,
        "2": 5,
        "3": 35,
        "4": 75,
        "5": 25,
        "6": 30,
        "7": 61,
        "8": 31,
        "9": 40,
        "10": 62,
        "11": 61,
        "12": 50,
        "13": 61,
        "14": 100,
        "15": 35,
        "16": 60,
        "17": 40,
        "18": 60,
        "19": 61,
        "20": 70,
        "21": 50,
        "22": 60,
        "23": 65,
        "24": 41,
        "25": 10,
        "26": 10,
        "27": 50,
        "28": 35,
        "29": 30,
        "30": 35,
        "31": 33,
        "32": 4,
        "33": 76,
        "34": 50,
        "35": 59,
        "36": 30,
        "37": 50,
        "38": 59,
        "39": 50,
        "40": 50,
        "41": 44,
        "42": 50,
        "43": 40,
        "44": 50,
        "45": 34,
        "46": 40,
        "47": 40,
        "48": 50,
        "49": 50,
        "50": 50,
        "51": 50,
        "52": 50,
        "53": 50,
        "54": 30,
        "55": 15,
        "56": 15,
        "57": 7,
        "58": 4,
        "59": 5,
        "60": 5,
        "61": 5,
        "62": 50,
        "63": 50,
        "64": 50,
        "65": 70,
        "66": 75,
        "67": 60,
        "68": 50,
        "69": 50,
        "70": 86
    },
    "ejlJEb39QEgMR1tdKf0rOYqSaWl1": {
        "1": 38,
        "2": 63,
        "3": 12,
        "4": 24,
        "5": 14,
        "6": 73,
        "7": 29,
        "8": 65,
        "9": 92,
        "10": 100,
        "11": 75,
        "12": 75,
        "13": 100,
        "14": 67,
        "15": 39,
        "16": 23,
        "17": 30,
        "18": 24,
        "19": 37,
        "20": 73,
        "21": 72,
        "22": 52,
        "23": 71,
        "24": 66,
        "25": 11,
        "26": 4,
        "27": 33,
        "28": 29,
        "29": 48,
        "30": 30,
        "31": 76,
        "32": 30,
        "33": 56,
        "34": 62,
        "35": 44,
        "36": 21,
        "37": 58,
        "38": 52,
        "39": 100,
        "40": 7,
        "41": 89,
        "42": 22,
        "43": 0,
        "44": 69,
        "45": 5,
        "46": 14,
        "47": 0,
        "48": 66,
        "49": 0,
        "50": 30,
        "51": 59,
        "52": 32,
        "53": 34,
        "54": 21,
        "55": 54,
        "56": 4,
        "57": 3,
        "58": 8,
        "59": 34,
        "60": 9,
        "61": 2,
        "62": 30,
        "63": 54,
        "64": 31,
        "65": 53,
        "66": 62,
        "67": 70,
        "68": 66,
        "69": 78,
        "70": 93
    },
    "XKQHbvrYdoa4CMR3UMkeEUOtDYa2": {
        "1": 68,
        "2": 100,
        "3": 0,
        "4": 100,
        "5": 10,
        "6": 5,
        "7": 11,
        "8": 33,
        "9": 100,
        "10": 100,
        "11": 44,
        "12": 86,
        "13": 14,
        "14": 85,
        "15": 63,
        "16": 81,
        "17": 29,
        "18": 32,
        "19": 36,
        "20": 91,
        "21": 50,
        "22": 36,
        "23": 81,
        "24": 72,
        "25": 21,
        "26": 20,
        "27": 22,
        "28": 75,
        "29": 28,
        "30": 19,
        "31": 28,
        "32": 69,
        "33": 0,
        "34": 21,
        "35": 15,
        "36": 27,
        "37": 30,
        "38": 21,
        "39": 100,
        "40": 25,
        "41": 67,
        "42": 39,
        "43": 38,
        "44": 34,
        "45": 35,
        "46": 40,
        "47": 19,
        "48": 12,
        "49": 67,
        "50": 87,
        "51": 26,
        "52": 68,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 29,
        "63": 50,
        "64": 72,
        "65": 68,
        "66": 23,
        "67": 79,
        "68": 26,
        "69": 81,
        "70": 89
    },
    "nN6I18XfBxQJCVJiHNObt9CEEEu2": {
        "1": 2,
        "2": 86,
        "3": 21,
        "4": 38,
        "5": 64,
        "6": 74,
        "7": 62,
        "8": 49,
        "9": 75,
        "10": 73,
        "11": 57,
        "12": 62,
        "13": 41,
        "14": 88,
        "15": 89,
        "16": 70,
        "17": 62,
        "18": 77,
        "19": 41,
        "20": 41,
        "21": 20,
        "22": 67,
        "23": 90,
        "24": 49,
        "25": 15,
        "26": 12,
        "27": 20,
        "28": 79,
        "29": 18,
        "30": 27,
        "31": 68,
        "32": 20,
        "33": 39,
        "34": 53,
        "35": 35,
        "36": 62,
        "37": 17,
        "38": 36,
        "39": 24,
        "40": 88,
        "41": 87,
        "42": 41,
        "43": 77,
        "44": 76,
        "45": 33,
        "46": 34,
        "47": 14,
        "48": 7,
        "49": 69,
        "50": 40,
        "51": 41,
        "52": 68,
        "53": 42,
        "54": 32,
        "55": 32,
        "56": 14,
        "57": 11,
        "58": 19,
        "59": 17,
        "60": 12,
        "61": 11,
        "62": 24,
        "63": 68,
        "64": 66,
        "65": 36,
        "66": 38,
        "67": 33,
        "68": 69,
        "69": 66,
        "70": 72
    },
    "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3": {
        "1": 41,
        "2": 53,
        "3": 10,
        "4": 64,
        "5": 8,
        "6": 60,
        "7": 27,
        "8": 70,
        "9": 60,
        "10": 85,
        "11": 30,
        "12": 67,
        "13": 40,
        "14": 67,
        "15": 80,
        "16": 35,
        "17": 15,
        "18": 43,
        "19": 57,
        "20": 92,
        "21": 81,
        "22": 60,
        "23": 55,
        "24": 70,
        "25": 16,
        "26": 28,
        "27": 18,
        "28": 35,
        "29": 15,
        "30": 36,
        "31": 55,
        "32": 15,
        "33": 70,
        "34": 60,
        "35": 40,
        "36": 36,
        "37": 10,
        "38": 20,
        "39": 60,
        "40": 27,
        "41": 34,
        "42": 25,
        "43": 13,
        "44": 38,
        "45": 31,
        "46": 26,
        "47": 54,
        "48": 22,
        "49": 35,
        "50": 50,
        "51": 24,
        "52": 59,
        "53": 7,
        "54": 24,
        "55": 52,
        "56": 30,
        "57": 5,
        "58": 0,
        "59": 1,
        "60": 4,
        "61": 0,
        "62": 14,
        "63": 61,
        "64": 65,
        "65": 15,
        "66": 7,
        "67": 37,
        "68": 57,
        "69": 37,
        "70": 61
    },
    "5QAP8wnbpWMd4Fde8bEAxiRhdI63": {
        "1": 5,
        "2": 15,
        "3": 25,
        "4": 75,
        "5": 25,
        "6": 20,
        "7": 30,
        "8": 60,
        "9": 30,
        "10": 35,
        "11": 64,
        "12": 40,
        "13": 5,
        "14": 65,
        "15": 20,
        "16": 90,
        "17": 64,
        "18": 15,
        "19": 55,
        "20": 89,
        "21": 75,
        "22": 81,
        "23": 65,
        "24": 20,
        "25": 20,
        "26": 5,
        "27": 25,
        "28": 20,
        "29": 55,
        "30": 30,
        "31": 55,
        "32": 55,
        "33": 35,
        "34": 65,
        "35": 65,
        "36": 30,
        "37": 15,
        "38": 65,
        "39": 75,
        "40": 85,
        "41": 35,
        "42": 25,
        "43": 15,
        "44": 25,
        "45": 30,
        "46": 35,
        "47": 15,
        "48": 25,
        "49": 50,
        "50": 30,
        "51": 60,
        "52": 30,
        "53": 40,
        "54": 10,
        "55": 45,
        "56": 5,
        "57": 1,
        "58": 1,
        "59": 5,
        "60": 10,
        "61": 1,
        "62": 1,
        "63": 50,
        "64": 60,
        "65": 75,
        "66": 65,
        "67": 55,
        "68": 35,
        "69": 55,
        "70": 85
    },
    "TJNLbfdP63dFx3P6GRqRk8JPa1K3": {
        "1": 100,
        "2": 23,
        "3": 0,
        "4": 28,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 66,
        "9": 48,
        "10": 34,
        "11": 50,
        "12": 68,
        "13": 0,
        "14": 38,
        "15": 50,
        "16": 64,
        "17": 41,
        "18": 37,
        "19": 60,
        "20": 92,
        "21": 100,
        "22": 67,
        "23": 100,
        "24": 16,
        "25": 0,
        "26": 0,
        "27": 39,
        "28": 0,
        "29": 39,
        "30": 0,
        "31": 0,
        "32": 27,
        "33": 12,
        "34": 67,
        "35": 68,
        "36": 18,
        "37": 59,
        "38": 37,
        "39": 58,
        "40": 22,
        "41": 66,
        "42": 32,
        "43": 38,
        "44": 46,
        "45": 19,
        "46": 5,
        "47": 36,
        "48": 13,
        "49": 48,
        "50": 60,
        "51": 81,
        "52": 50,
        "53": 37,
        "54": 6,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 65,
        "64": 66,
        "65": 0,
        "66": 75,
        "67": 82,
        "68": 73,
        "69": 66,
        "70": 100
    },
    "VjWrZoDq6KYTqZGY4LG4Zv3w52E3": {
        "1": 70,
        "2": 54,
        "3": 22,
        "4": 100,
        "5": 31,
        "6": 40,
        "7": 63,
        "8": 27,
        "9": 78,
        "10": 68,
        "11": 67,
        "12": 45,
        "13": 67,
        "14": 76,
        "15": 64,
        "16": 72,
        "17": 57,
        "18": 36,
        "19": 61,
        "20": 100,
        "21": 100,
        "22": 44,
        "23": 71,
        "24": 60,
        "25": 27,
        "26": 33,
        "27": 67,
        "28": 29,
        "29": 64,
        "30": 33,
        "31": 62,
        "32": 37,
        "33": 100,
        "34": 72,
        "35": 77,
        "36": 28,
        "37": 66,
        "38": 66,
        "39": 87,
        "40": 100,
        "41": 74,
        "42": 41,
        "43": 36,
        "44": 75,
        "45": 50,
        "46": 36,
        "47": 50,
        "48": 70,
        "49": 33,
        "50": 50,
        "51": 73,
        "52": 50,
        "53": 50,
        "54": 50,
        "55": 50,
        "56": 50,
        "57": 26,
        "58": 5,
        "59": 8,
        "60": 3,
        "61": 13,
        "62": 14,
        "63": 50,
        "64": 64,
        "65": 26,
        "66": 31,
        "67": 30,
        "68": 43,
        "69": 59,
        "70": 50
    },
    "0n2keiWoSnelLAQoRprKqIlOAw72": {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 100,
        "12": 0,
        "13": 0,
        "14": 100,
        "15": 100,
        "16": 0,
        "17": 0,
        "18": 0,
        "19": 0,
        "20": 0,
        "21": 100,
        "22": 100,
        "23": 100,
        "24": 0,
        "25": 0,
        "26": 0,
        "27": 100,
        "28": 100,
        "29": 0,
        "30": 0,
        "31": 100,
        "32": 0,
        "33": 100,
        "34": 0,
        "35": 0,
        "36": 0,
        "37": 0,
        "38": 0,
        "39": 100,
        "40": 100,
        "41": 0,
        "42": 0,
        "43": 0,
        "44": 0,
        "45": 0,
        "46": 0,
        "47": 0,
        "48": 0,
        "49": 0,
        "50": 100,
        "51": 100,
        "52": 0,
        "53": 100,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 100,
        "64": 100,
        "65": 0,
        "66": 100,
        "67": 0,
        "68": 100,
        "69": 100,
        "70": 100
    },
    "rPuHOVYe1nPeiDSSHwMTJRRkfon1": {
        "1": 81,
        "2": 15,
        "3": 9,
        "4": 84,
        "5": 6,
        "6": 76,
        "7": 12,
        "8": 16,
        "9": 88,
        "10": 37,
        "11": 50,
        "12": 40,
        "13": 34,
        "14": 40,
        "15": 4,
        "16": 82,
        "17": 10,
        "18": 25,
        "19": 76,
        "20": 76,
        "21": 74,
        "22": 30,
        "23": 70,
        "24": 28,
        "25": 11,
        "26": 5,
        "27": 35,
        "28": 7,
        "29": 71,
        "30": 80,
        "31": 87,
        "32": 2,
        "33": 42,
        "34": 35,
        "35": 30,
        "36": 30,
        "37": 74,
        "38": 22,
        "39": 38,
        "40": 50,
        "41": 28,
        "42": 22,
        "43": 12,
        "44": 19,
        "45": 85,
        "46": 90,
        "47": 6,
        "48": 50,
        "49": 50,
        "50": 76,
        "51": 72,
        "52": 42,
        "53": 30,
        "54": 30,
        "55": 23,
        "56": 10,
        "57": 5,
        "58": 3,
        "59": 1,
        "60": 4,
        "61": 1,
        "62": 21,
        "63": 22,
        "64": 62,
        "65": 11,
        "66": 71,
        "67": 75,
        "68": 33,
        "69": 12,
        "70": 91
    },
    "iXluLvciaxggHvyPkvRkFxDHTjz1": {
        "1": 70,
        "2": 69,
        "3": 5,
        "4": 90,
        "5": 10,
        "6": 20,
        "7": 20,
        "8": 69,
        "9": 75,
        "10": 10,
        "11": 30,
        "12": 30,
        "13": 20,
        "14": 60,
        "15": 30,
        "16": 70,
        "17": 20,
        "18": 15,
        "19": 55,
        "20": 60,
        "21": 20,
        "22": 60,
        "23": 75,
        "24": 20,
        "25": 20,
        "26": 10,
        "27": 30,
        "28": 25,
        "29": 30,
        "30": 15,
        "31": 30,
        "32": 10,
        "33": 20,
        "34": 20,
        "35": 20,
        "36": 30,
        "37": 35,
        "38": 20,
        "39": 90,
        "40": 80,
        "41": 81,
        "42": 70,
        "43": 20,
        "44": 50,
        "45": 15,
        "46": 35,
        "47": 10,
        "48": 70,
        "49": 50,
        "50": 15,
        "51": 15,
        "52": 40,
        "53": 40,
        "54": 15,
        "55": 20,
        "56": 1,
        "57": 2,
        "58": 10,
        "59": 10,
        "60": 5,
        "61": 2,
        "62": 20,
        "63": 15,
        "64": 65,
        "65": 25,
        "66": 65,
        "67": 20,
        "68": 70,
        "69": 20,
        "70": 80
    },
    "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3": {
        "1": 40,
        "2": 0,
        "3": 0,
        "4": 81,
        "5": 0,
        "6": 0,
        "7": 20,
        "8": 0,
        "9": 100,
        "10": 0,
        "11": 76,
        "12": 100,
        "13": 0,
        "14": 100,
        "15": 0,
        "16": 0,
        "17": 86,
        "18": 0,
        "19": 38,
        "20": 100,
        "21": 100,
        "22": 14,
        "23": 50,
        "24": 86,
        "25": 0,
        "26": 0,
        "27": 0,
        "28": 0,
        "29": 0,
        "30": 87,
        "31": 0,
        "32": 0,
        "33": 0,
        "34": 30,
        "35": 100,
        "36": 69,
        "37": 78,
        "38": 0,
        "39": 100,
        "40": 100,
        "41": 100,
        "42": 0,
        "43": 0,
        "44": 0,
        "45": 0,
        "46": 100,
        "47": 0,
        "48": 100,
        "49": 100,
        "50": 0,
        "51": 0,
        "52": 0,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 31,
        "64": 0,
        "65": 18,
        "66": 20,
        "67": 100,
        "68": 23,
        "69": 100,
        "70": 100
    },
    "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2": {
        "1": 90,
        "2": 12,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 5,
        "7": 0,
        "8": 25,
        "9": 100,
        "10": 45,
        "11": 62,
        "12": 21,
        "13": 0,
        "14": 6,
        "15": 0,
        "16": 47,
        "17": 0,
        "18": 35,
        "19": 39,
        "20": 12,
        "21": 100,
        "22": 0,
        "23": 92,
        "24": 82,
        "25": 0,
        "26": 0,
        "27": 87,
        "28": 0,
        "29": 94,
        "30": 39,
        "31": 0,
        "32": 0,
        "33": 0,
        "34": 17,
        "35": 56,
        "36": 16,
        "37": 20,
        "38": 13,
        "39": 73,
        "40": 84,
        "41": 82,
        "42": 0,
        "43": 27,
        "44": 63,
        "45": 39,
        "46": 43,
        "47": 0,
        "48": 36,
        "49": 0,
        "50": 54,
        "51": 54,
        "52": 55,
        "53": 56,
        "54": 57,
        "55": 58,
        "56": 36,
        "57": 35,
        "58": 56,
        "59": 37,
        "60": 38,
        "61": 38,
        "62": 55,
        "63": 40,
        "64": 57,
        "65": 0,
        "66": 0,
        "67": 0,
        "68": 0,
        "69": 73,
        "70": 0
    },
    "MPq8rZEN7YRZfSF01L31cNQ7Zjs1": {
        "1": 15,
        "2": 35,
        "3": 35,
        "4": 75,
        "5": 30,
        "6": 12,
        "7": 8,
        "8": 15,
        "9": 64,
        "10": 41,
        "11": 28,
        "12": 26,
        "13": 14,
        "14": 33,
        "15": 15,
        "16": 60,
        "17": 66,
        "18": 20,
        "19": 29,
        "20": 60,
        "21": 78,
        "22": 20,
        "23": 89,
        "24": 20,
        "25": 16,
        "26": 0,
        "27": 60,
        "28": 18,
        "29": 66,
        "30": 56,
        "31": 25,
        "32": 14,
        "33": 15,
        "34": 18,
        "35": 21,
        "36": 33,
        "37": 20,
        "38": 69,
        "39": 40,
        "40": 90,
        "41": 30,
        "42": 68,
        "43": 10,
        "44": 74,
        "45": 82,
        "46": 36,
        "47": 6,
        "48": 17,
        "49": 16,
        "50": 30,
        "51": 55,
        "52": 33,
        "53": 61,
        "54": 14,
        "55": 11,
        "56": 11,
        "57": 7,
        "58": 8,
        "59": 10,
        "60": 6,
        "61": 8,
        "62": 14,
        "63": 23,
        "64": 24,
        "65": 29,
        "66": 26,
        "67": 73,
        "68": 50,
        "69": 25,
        "70": 50
    },
    "760DR5EYoHMAgCgPv1bFFJkOLyM2": {
        "1": 40,
        "2": 50,
        "3": 22,
        "4": 76,
        "5": 37,
        "6": 43,
        "7": 28,
        "8": 63,
        "9": 79,
        "10": 28,
        "11": 64,
        "12": 70,
        "13": 31,
        "14": 75,
        "15": 70,
        "16": 100,
        "17": 35,
        "18": 12,
        "19": 77,
        "20": 76,
        "21": 75,
        "22": 11,
        "23": 77,
        "24": 20,
        "25": 16,
        "26": 12,
        "27": 14,
        "28": 0,
        "29": 19,
        "30": 72,
        "31": 21,
        "32": 29,
        "33": 28,
        "34": 14,
        "35": 80,
        "36": 5,
        "37": 39,
        "38": 16,
        "39": 100,
        "40": 100,
        "41": 74,
        "42": 0,
        "43": 0,
        "44": 72,
        "45": 31,
        "46": 64,
        "47": 50,
        "48": 10,
        "49": 30,
        "50": 32,
        "51": 66,
        "52": 19,
        "53": 42,
        "54": 22,
        "55": 0,
        "56": 50,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 12,
        "63": 15,
        "64": 15,
        "65": 26,
        "66": 74,
        "67": 82,
        "68": 12,
        "69": 85,
        "70": 100
    },
    "hzUhUMArMPRsB8dEMzXZkYXLf5o2": {
        "1": 20,
        "2": 31,
        "3": 21,
        "4": 35,
        "5": 11,
        "6": 30,
        "7": 11,
        "8": 71,
        "9": 65,
        "10": 25,
        "11": 29,
        "12": 69,
        "13": 15,
        "14": 26,
        "15": 24,
        "16": 67,
        "17": 70,
        "18": 12,
        "19": 31,
        "20": 30,
        "21": 75,
        "22": 80,
        "23": 93,
        "24": 15,
        "25": 3,
        "26": 10,
        "27": 27,
        "28": 31,
        "29": 20,
        "30": 14,
        "31": 30,
        "32": 18,
        "33": 30,
        "34": 8,
        "35": 18,
        "36": 20,
        "37": 70,
        "38": 76,
        "39": 67,
        "40": 74,
        "41": 24,
        "42": 24,
        "43": 11,
        "44": 80,
        "45": 71,
        "46": 20,
        "47": 65,
        "48": 33,
        "49": 18,
        "50": 20,
        "51": 60,
        "52": 32,
        "53": 17,
        "54": 12,
        "55": 26,
        "56": 15,
        "57": 5,
        "58": 5,
        "59": 5,
        "60": 3,
        "61": 5,
        "62": 6,
        "63": 63,
        "64": 66,
        "65": 0,
        "66": 60,
        "67": 70,
        "68": 75,
        "69": 71,
        "70": 86
    },
    "8Fm6SqAasThu2UFSPYSOh2ACgcA3": {
        "1": 23,
        "2": 59,
        "3": 30,
        "4": 78,
        "5": 41,
        "6": 38,
        "7": 56,
        "8": 55,
        "9": 40,
        "10": 50,
        "11": 60,
        "12": 41,
        "13": 59,
        "14": 40,
        "15": 27,
        "16": 72,
        "17": 50,
        "18": 40,
        "19": 58,
        "20": 90,
        "21": 12,
        "22": 27,
        "23": 66,
        "24": 38,
        "25": 39,
        "26": 27,
        "27": 68,
        "28": 31,
        "29": 60,
        "30": 58,
        "31": 64,
        "32": 42,
        "33": 37,
        "34": 38,
        "35": 35,
        "36": 23,
        "37": 60,
        "38": 56,
        "39": 66,
        "40": 37,
        "41": 35,
        "42": 35,
        "43": 26,
        "44": 60,
        "45": 42,
        "46": 37,
        "47": 33,
        "48": 30,
        "49": 65,
        "50": 0,
        "51": 67,
        "52": 45,
        "53": 24,
        "54": 74,
        "55": 44,
        "56": 38,
        "57": 20,
        "58": 27,
        "59": 24,
        "60": 23,
        "61": 26,
        "62": 91,
        "63": 62,
        "64": 61,
        "65": 58,
        "66": 76,
        "67": 40,
        "68": 62,
        "69": 60,
        "70": 37
    },
    "LZfDcvvLbxfjIby3Rcd6DNhiOPI3": {
        "1": 100,
        "2": 53,
        "3": 12,
        "4": 70,
        "5": 5,
        "6": 80,
        "7": 89,
        "8": 21,
        "9": 100,
        "10": 100,
        "11": 100,
        "12": 20,
        "13": 44,
        "14": 72,
        "15": 65,
        "16": 18,
        "17": 0,
        "18": 0,
        "19": 100,
        "20": 84,
        "21": 45,
        "22": 79,
        "23": 100,
        "24": 18,
        "25": 18,
        "26": 18,
        "27": 16,
        "28": 20,
        "29": 53,
        "30": 13,
        "31": 67,
        "32": 28,
        "33": 100,
        "34": 100,
        "35": 48,
        "36": 0,
        "37": 27,
        "38": 85,
        "39": 70,
        "40": 100,
        "41": 16,
        "42": 70,
        "43": 36,
        "44": 74,
        "45": 0,
        "46": 15,
        "47": 37,
        "48": 71,
        "49": 20,
        "50": 0,
        "51": 62,
        "52": 61,
        "53": 23,
        "54": 20,
        "55": 66,
        "56": 25,
        "57": 0,
        "58": 0,
        "59": 23,
        "60": 2,
        "61": 7,
        "62": 32,
        "63": 100,
        "64": 100,
        "65": 0,
        "66": 35,
        "67": 70,
        "68": 42,
        "69": 75,
        "70": 100
    },
    "byCHQ45GOdQGYA7xVuXIksS9Cuo2": {
        "1": 28,
        "2": 79,
        "3": 6,
        "4": 75,
        "5": 31,
        "6": 0,
        "7": 0,
        "8": 34,
        "9": 70,
        "10": 31,
        "11": 60,
        "12": 69,
        "13": 6,
        "14": 14,
        "15": 11,
        "16": 70,
        "17": 10,
        "18": 18,
        "19": 16,
        "20": 61,
        "21": 45,
        "22": 60,
        "23": 72,
        "24": 45,
        "25": 8,
        "26": 7,
        "27": 39,
        "28": 26,
        "29": 60,
        "30": 38,
        "31": 20,
        "32": 16,
        "33": 43,
        "34": 60,
        "35": 61,
        "36": 40,
        "37": 58,
        "38": 60,
        "39": 90,
        "40": 65,
        "41": 70,
        "42": 41,
        "43": 12,
        "44": 31,
        "45": 57,
        "46": 31,
        "47": 62,
        "48": 21,
        "49": 23,
        "50": 59,
        "51": 34,
        "52": 45,
        "53": 56,
        "54": 35,
        "55": 42,
        "56": 28,
        "57": 3,
        "58": 5,
        "59": 6,
        "60": 7,
        "61": 8,
        "62": 26,
        "63": 32,
        "64": 64,
        "65": 73,
        "66": 90,
        "67": 60,
        "68": 61,
        "69": 71,
        "70": 74
    },
    "doCBkJRwgiXllMNMixBgRjugXR43": {
        "1": 20,
        "2": 20,
        "3": 30,
        "4": 70,
        "5": 40,
        "6": 70,
        "7": 62,
        "8": 67,
        "9": 60,
        "10": 100,
        "11": 82,
        "12": 33,
        "13": 80,
        "14": 85,
        "15": 66,
        "16": 83,
        "17": 72,
        "18": 43,
        "19": 61,
        "20": 14,
        "21": 29,
        "22": 63,
        "23": 63,
        "24": 31,
        "25": 34,
        "26": 32,
        "27": 61,
        "28": 35,
        "29": 66,
        "30": 55,
        "31": 66,
        "32": 71,
        "33": 55,
        "34": 35,
        "35": 53,
        "36": 16,
        "37": 36,
        "38": 62,
        "39": 92,
        "40": 86,
        "41": 28,
        "42": 14,
        "43": 25,
        "44": 60,
        "45": 29,
        "46": 33,
        "47": 23,
        "48": 80,
        "49": 60,
        "50": 82,
        "51": 82,
        "52": 72,
        "53": 33,
        "54": 26,
        "55": 26,
        "56": 6,
        "57": 2,
        "58": 6,
        "59": 4,
        "60": 6,
        "61": 3,
        "62": 41,
        "63": 71,
        "64": 69,
        "65": 17,
        "66": 29,
        "67": 78,
        "68": 62,
        "69": 93,
        "70": 71
    },
    "KR7TVIagpmX36dxJ03fm1kUAIPE3": {
        "1": 85,
        "2": 25,
        "3": 40,
        "4": 60,
        "5": 10,
        "6": 25,
        "7": 10,
        "8": 65,
        "9": 10,
        "10": 0,
        "11": 30,
        "12": 75,
        "13": 25,
        "14": 69,
        "15": 25,
        "16": 65,
        "17": 70,
        "18": 10,
        "19": 10,
        "20": 60,
        "21": 90,
        "22": 75,
        "23": 100,
        "24": 10,
        "25": 23,
        "26": 5,
        "27": 55,
        "28": 30,
        "29": 20,
        "30": 10,
        "31": 10,
        "32": 0,
        "33": 40,
        "34": 25,
        "35": 90,
        "36": 0,
        "37": 30,
        "38": 60,
        "39": 80,
        "40": 70,
        "41": 20,
        "42": 15,
        "43": 0,
        "44": 10,
        "45": 50,
        "46": 0,
        "47": 30,
        "48": 15,
        "49": 15,
        "50": 53,
        "51": 50,
        "52": 50,
        "53": 46,
        "54": 0,
        "55": 10,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 15,
        "63": 12,
        "64": 12,
        "65": 25,
        "66": 50,
        "67": 40,
        "68": 60,
        "69": 10,
        "70": 80
    },
    "EVi1gWi2d1hBbnsOWFJZmqaRUBs1": {
        "1": 35,
        "2": 15,
        "3": 25,
        "4": 60,
        "5": 29,
        "6": 40,
        "7": 30,
        "8": 72,
        "9": 34,
        "10": 25,
        "11": 30,
        "12": 63,
        "13": 30,
        "14": 70,
        "15": 41,
        "16": 82,
        "17": 55,
        "18": 65,
        "19": 42,
        "20": 32,
        "21": 47,
        "22": 60,
        "23": 66,
        "24": 23,
        "25": 25,
        "26": 20,
        "27": 36,
        "28": 25,
        "29": 29,
        "30": 36,
        "31": 35,
        "32": 41,
        "33": 20,
        "34": 25,
        "35": 60,
        "36": 25,
        "37": 33,
        "38": 21,
        "39": 70,
        "40": 40,
        "41": 70,
        "42": 40,
        "43": 41,
        "44": 66,
        "45": 20,
        "46": 24,
        "47": 79,
        "48": 20,
        "49": 30,
        "50": 63,
        "51": 64,
        "52": 68,
        "53": 30,
        "54": 20,
        "55": 9,
        "56": 9,
        "57": 5,
        "58": 3,
        "59": 6,
        "60": 5,
        "61": 3,
        "62": 20,
        "63": 66,
        "64": 66,
        "65": 31,
        "66": 50,
        "67": 65,
        "68": 40,
        "69": 65,
        "70": 75
    },
    "DZlHlCzb6xgGLwzrmUfjOv1a33t2": {
        "1": 67,
        "2": 92,
        "3": 7,
        "4": 93,
        "5": 5,
        "6": 20,
        "7": 2,
        "8": 75,
        "9": 85,
        "10": 20,
        "11": 60,
        "12": 33,
        "13": 5,
        "14": 33,
        "15": 20,
        "16": 52,
        "17": 66,
        "18": 10,
        "19": 15,
        "20": 90,
        "21": 85,
        "22": 66,
        "23": 75,
        "24": 66,
        "25": 25,
        "26": 5,
        "27": 40,
        "28": 5,
        "29": 20,
        "30": 20,
        "31": 10,
        "32": 15,
        "33": 2,
        "34": 7,
        "35": 95,
        "36": 3,
        "37": 10,
        "38": 5,
        "39": 90,
        "40": 10,
        "41": 70,
        "42": 7,
        "43": 9,
        "44": 55,
        "45": 25,
        "46": 3,
        "47": 65,
        "48": 10,
        "49": 10,
        "50": 60,
        "51": 93,
        "52": 95,
        "53": 30,
        "54": 5,
        "55": 10,
        "56": 1,
        "57": 3,
        "58": 1,
        "59": 1,
        "60": 3,
        "61": 1,
        "62": 55,
        "63": 75,
        "64": 25,
        "65": 33,
        "66": 61,
        "67": 56,
        "68": 50,
        "69": 69,
        "70": 69
    },
    "QE94oK9a3zX9xIjawUHBBKe46ID3": {
        "1": 32,
        "2": 65,
        "3": 20,
        "4": 82,
        "5": 10,
        "6": 55,
        "7": 24,
        "8": 35,
        "9": 65,
        "10": 92,
        "11": 50,
        "12": 70,
        "13": 95,
        "14": 91,
        "15": 0,
        "16": 68,
        "17": 58,
        "18": 15,
        "19": 81,
        "20": 72,
        "21": 74,
        "22": 40,
        "23": 50,
        "24": 20,
        "25": 0,
        "26": 15,
        "27": 30,
        "28": 20,
        "29": 10,
        "30": 50,
        "31": 50,
        "32": 30,
        "33": 66,
        "34": 32,
        "35": 70,
        "36": 15,
        "37": 50,
        "38": 69,
        "39": 47,
        "40": 36,
        "41": 64,
        "42": 45,
        "43": 14,
        "44": 15,
        "45": 40,
        "46": 29,
        "47": 0,
        "48": 0,
        "49": 30,
        "50": 26,
        "51": 62,
        "52": 50,
        "53": 35,
        "54": 15,
        "55": 40,
        "56": 10,
        "57": 20,
        "58": 59,
        "59": 10,
        "60": 57,
        "61": 0,
        "62": 30,
        "63": 66,
        "64": 50,
        "65": 63,
        "66": 69,
        "67": 50,
        "68": 80,
        "69": 93,
        "70": 72
    },
    "3XKX87mYx3eLIDsf4YQJhzcKSCh2": {
        "1": 100,
        "2": 0,
        "3": 0,
        "4": 100,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 100,
        "11": 100,
        "12": 100,
        "13": 0,
        "14": 100,
        "15": 0,
        "16": 0,
        "17": 100,
        "18": 100,
        "19": 100,
        "20": 100,
        "21": 0,
        "22": 0,
        "23": 100,
        "24": 0,
        "25": 1,
        "26": 0,
        "27": 0,
        "28": 0,
        "29": 0,
        "30": 0,
        "31": 0,
        "32": 0,
        "33": 0,
        "34": 0,
        "35": 100,
        "36": 0,
        "37": 0,
        "38": 1,
        "39": 100,
        "40": 0,
        "41": 8,
        "42": 100,
        "43": 0,
        "44": 0,
        "45": 0,
        "46": 2,
        "47": 100,
        "48": 0,
        "49": 0,
        "50": 100,
        "51": 0,
        "52": 0,
        "53": 0,
        "54": 0,
        "55": 0,
        "56": 0,
        "57": 0,
        "58": 0,
        "59": 0,
        "60": 0,
        "61": 0,
        "62": 0,
        "63": 89,
        "64": 0,
        "65": 100,
        "66": 0,
        "67": 0,
        "68": 1,
        "69": 0,
        "70": 100
    }
};


export const allUserResponses = {
    "1": [
        75,
        5,
        8,
        42,
        10,
        72,
        87,
        0,
        39,
        89,
        11,
        20,
        100,
        50,
        0,
        0,
        0,
        28,
        100,
        67,
        20,
        20,
        100,
        0,
        20,
        15,
        33,
        65,
        0,
        50,
        54,
        27,
        100,
        20,
        72,
        72,
        10,
        0,
        25,
        38,
        68,
        2,
        41,
        5,
        100,
        70,
        0,
        81,
        70,
        40,
        90,
        15,
        40,
        20,
        23,
        100,
        28,
        20,
        85,
        35,
        67,
        32,
        100
    ],
    "2": [
        72,
        10,
        69,
        85,
        10,
        3,
        82,
        18,
        56,
        25,
        64,
        12,
        67,
        10,
        100,
        40,
        100,
        28,
        95,
        0,
        100,
        55,
        91,
        67,
        71,
        80,
        65,
        30,
        21,
        60,
        27,
        80,
        100,
        30,
        3,
        68,
        0,
        76,
        5,
        63,
        100,
        86,
        53,
        15,
        23,
        54,
        0,
        15,
        69,
        0,
        12,
        35,
        50,
        31,
        59,
        53,
        79,
        20,
        25,
        15,
        92,
        65,
        0
    ],
    "3": [
        30,
        29,
        10,
        82,
        18,
        13,
        50,
        4,
        33,
        20,
        25,
        35,
        0,
        20,
        0,
        66,
        0,
        42,
        0,
        41,
        35,
        20,
        1,
        32,
        35,
        25,
        6,
        70,
        7,
        55,
        41,
        21,
        0,
        70,
        13,
        57,
        75,
        0,
        35,
        12,
        0,
        21,
        10,
        25,
        0,
        22,
        0,
        9,
        5,
        0,
        0,
        35,
        22,
        21,
        30,
        12,
        6,
        30,
        40,
        25,
        7,
        20,
        0
    ],
    "4": [
        84,
        60,
        89,
        62,
        65,
        88,
        100,
        0,
        66,
        85,
        95,
        37,
        100,
        25,
        100,
        30,
        100,
        69,
        100,
        64,
        80,
        95,
        75,
        100,
        45,
        60,
        95,
        90,
        50,
        65,
        69,
        75,
        100,
        30,
        88,
        28,
        70,
        85,
        75,
        24,
        100,
        38,
        64,
        75,
        28,
        100,
        100,
        84,
        90,
        81,
        100,
        75,
        76,
        35,
        78,
        70,
        75,
        70,
        60,
        60,
        93,
        82,
        100
    ],
    "5": [
        68,
        20,
        18,
        63,
        24,
        18,
        89,
        0,
        41,
        25,
        30,
        50,
        0,
        0,
        0,
        0,
        9,
        37,
        0,
        45,
        20,
        10,
        7,
        66,
        45,
        35,
        1,
        50,
        19,
        50,
        59,
        25,
        0,
        70,
        18,
        77,
        0,
        0,
        25,
        14,
        10,
        64,
        8,
        25,
        0,
        31,
        0,
        6,
        10,
        0,
        0,
        30,
        37,
        11,
        41,
        5,
        31,
        40,
        10,
        29,
        5,
        10,
        0
    ],
    "6": [
        82,
        20,
        53,
        46,
        20,
        12,
        36,
        0,
        61,
        5,
        80,
        30,
        0,
        0,
        0,
        0,
        63,
        12,
        14,
        61,
        15,
        15,
        16,
        36,
        50,
        40,
        10,
        75,
        80,
        50,
        54,
        31,
        0,
        60,
        12,
        100,
        50,
        0,
        30,
        73,
        5,
        74,
        60,
        20,
        0,
        40,
        0,
        76,
        20,
        0,
        5,
        12,
        43,
        30,
        38,
        80,
        0,
        70,
        25,
        40,
        20,
        55,
        0
    ],
    "7": [
        70,
        10,
        34,
        43,
        20,
        0,
        59,
        21,
        60,
        5,
        24,
        38,
        0,
        0,
        0,
        10,
        62,
        50,
        18,
        43,
        0,
        65,
        47,
        35,
        50,
        35,
        20,
        70,
        13,
        55,
        28,
        21,
        0,
        40,
        0,
        61,
        50,
        24,
        61,
        29,
        11,
        62,
        27,
        30,
        0,
        63,
        0,
        12,
        20,
        20,
        0,
        8,
        28,
        11,
        56,
        89,
        0,
        62,
        10,
        30,
        2,
        24,
        0
    ],
    "8": [
        64,
        20,
        15,
        83,
        5,
        32,
        37,
        25,
        70,
        35,
        66,
        50,
        25,
        0,
        0,
        10,
        0,
        0,
        16,
        69,
        60,
        100,
        44,
        75,
        25,
        25,
        10,
        40,
        66,
        60,
        20,
        35,
        100,
        80,
        32,
        0,
        0,
        67,
        31,
        65,
        33,
        49,
        70,
        60,
        66,
        27,
        0,
        16,
        69,
        0,
        25,
        15,
        63,
        71,
        55,
        21,
        34,
        67,
        65,
        72,
        75,
        35,
        0
    ],
    "9": [
        40,
        70,
        28,
        82,
        40,
        87,
        39,
        92,
        50,
        60,
        85,
        53,
        25,
        60,
        100,
        5,
        100,
        63,
        78,
        38,
        50,
        65,
        41,
        82,
        30,
        70,
        51,
        65,
        69,
        40,
        40,
        71,
        0,
        20,
        87,
        20,
        85,
        88,
        40,
        92,
        100,
        75,
        60,
        30,
        48,
        78,
        0,
        88,
        75,
        100,
        100,
        64,
        79,
        65,
        40,
        100,
        70,
        60,
        10,
        34,
        85,
        65,
        0
    ],
    "10": [
        74,
        70,
        92,
        79,
        40,
        20,
        50,
        66,
        65,
        75,
        100,
        50,
        100,
        10,
        0,
        0,
        100,
        65,
        10,
        60,
        20,
        10,
        44,
        81,
        30,
        30,
        80,
        45,
        50,
        25,
        62,
        79,
        0,
        90,
        20,
        41,
        70,
        20,
        62,
        100,
        100,
        73,
        85,
        35,
        34,
        68,
        0,
        37,
        10,
        0,
        45,
        41,
        28,
        25,
        50,
        100,
        31,
        100,
        0,
        25,
        20,
        92,
        100
    ],
    "11": [
        70,
        70,
        50,
        47,
        30,
        71,
        80,
        66,
        43,
        10,
        79,
        60,
        77,
        5,
        0,
        15,
        79,
        57,
        34,
        71,
        30,
        85,
        59,
        100,
        40,
        60,
        35,
        40,
        86,
        40,
        67,
        65,
        100,
        85,
        71,
        26,
        100,
        45,
        61,
        75,
        44,
        57,
        30,
        64,
        50,
        67,
        100,
        50,
        30,
        76,
        62,
        28,
        64,
        29,
        60,
        100,
        60,
        82,
        30,
        30,
        60,
        50,
        100
    ],
    "12": [
        39,
        20,
        30,
        34,
        60,
        71,
        31,
        11,
        43,
        25,
        68,
        60,
        76,
        40,
        12,
        25,
        0,
        30,
        69,
        30,
        70,
        35,
        58,
        82,
        70,
        20,
        65,
        55,
        31,
        70,
        45,
        60,
        100,
        60,
        71,
        74,
        0,
        80,
        50,
        75,
        86,
        62,
        67,
        40,
        68,
        45,
        0,
        40,
        30,
        100,
        21,
        26,
        70,
        69,
        41,
        20,
        69,
        33,
        75,
        63,
        33,
        70,
        100
    ],
    "13": [
        50,
        70,
        52,
        96,
        1,
        23,
        50,
        97,
        67,
        0,
        100,
        50,
        0,
        0,
        0,
        0,
        0,
        43,
        0,
        39,
        35,
        20,
        47,
        37,
        51,
        80,
        3,
        85,
        62,
        50,
        4,
        9,
        0,
        70,
        23,
        79,
        40,
        0,
        61,
        100,
        14,
        41,
        40,
        5,
        0,
        67,
        0,
        34,
        20,
        0,
        0,
        14,
        31,
        15,
        59,
        44,
        6,
        80,
        25,
        30,
        5,
        95,
        0
    ],
    "14": [
        34,
        90,
        26,
        26,
        70,
        19,
        70,
        36,
        61,
        35,
        75,
        50,
        93,
        0,
        78,
        25,
        85,
        62,
        89,
        32,
        35,
        60,
        42,
        100,
        62,
        100,
        80,
        70,
        50,
        90,
        65,
        75,
        100,
        85,
        19,
        96,
        50,
        21,
        100,
        67,
        85,
        88,
        67,
        65,
        38,
        76,
        100,
        40,
        60,
        100,
        6,
        33,
        75,
        26,
        40,
        72,
        14,
        85,
        69,
        70,
        33,
        91,
        100
    ],
    "15": [
        32,
        20,
        3,
        24,
        40,
        34,
        100,
        36,
        68,
        25,
        44,
        55,
        100,
        5,
        25,
        5,
        67,
        60,
        100,
        40,
        0,
        50,
        3,
        40,
        20,
        20,
        65,
        35,
        0,
        50,
        68,
        65,
        100,
        90,
        34,
        77,
        25,
        15,
        35,
        39,
        63,
        89,
        80,
        20,
        50,
        64,
        100,
        4,
        30,
        0,
        0,
        15,
        70,
        24,
        27,
        65,
        11,
        66,
        25,
        41,
        20,
        0,
        0
    ],
    "16": [
        66,
        70,
        85,
        82,
        60,
        30,
        70,
        67,
        74,
        30,
        26,
        50,
        100,
        50,
        89,
        30,
        33,
        77,
        18,
        67,
        75,
        35,
        62,
        100,
        50,
        75,
        38,
        70,
        39,
        70,
        40,
        65,
        100,
        40,
        30,
        28,
        35,
        67,
        60,
        23,
        81,
        70,
        35,
        90,
        64,
        72,
        0,
        82,
        70,
        0,
        47,
        60,
        100,
        67,
        72,
        18,
        70,
        83,
        65,
        82,
        52,
        68,
        0
    ],
    "17": [
        35,
        70,
        82,
        43,
        20,
        16,
        0,
        68,
        50,
        20,
        20,
        40,
        0,
        0,
        20,
        15,
        0,
        24,
        0,
        36,
        60,
        5,
        52,
        61,
        61,
        90,
        78,
        30,
        42,
        65,
        66,
        33,
        0,
        10,
        16,
        26,
        20,
        33,
        40,
        30,
        29,
        62,
        15,
        64,
        41,
        57,
        0,
        10,
        20,
        86,
        0,
        66,
        35,
        70,
        50,
        0,
        10,
        72,
        70,
        55,
        66,
        58,
        100
    ],
    "18": [
        50,
        19,
        27,
        53,
        0,
        21,
        88,
        10,
        50,
        20,
        19,
        34,
        0,
        0,
        0,
        0,
        17,
        32,
        100,
        22,
        50,
        30,
        58,
        23,
        56,
        65,
        20,
        60,
        0,
        80,
        15,
        35,
        0,
        35,
        21,
        73,
        0,
        0,
        60,
        24,
        32,
        77,
        43,
        15,
        37,
        36,
        0,
        25,
        15,
        0,
        35,
        20,
        12,
        12,
        40,
        0,
        18,
        43,
        10,
        65,
        10,
        15,
        100
    ],
    "19": [
        69,
        30,
        13,
        44,
        40,
        38,
        78,
        75,
        63,
        30,
        37,
        59,
        17,
        80,
        21,
        33,
        79,
        65,
        40,
        31,
        70,
        55,
        46,
        34,
        59,
        65,
        33,
        50,
        45,
        70,
        43,
        66,
        100,
        80,
        38,
        17,
        0,
        20,
        61,
        37,
        36,
        41,
        57,
        55,
        60,
        61,
        0,
        76,
        55,
        38,
        39,
        29,
        77,
        31,
        58,
        100,
        16,
        61,
        10,
        42,
        15,
        81,
        100
    ],
    "20": [
        62,
        20,
        79,
        58,
        80,
        91,
        50,
        70,
        97,
        15,
        73,
        85,
        89,
        90,
        80,
        95,
        100,
        0,
        71,
        59,
        70,
        5,
        55,
        0,
        65,
        35,
        36,
        80,
        100,
        70,
        63,
        85,
        100,
        5,
        91,
        0,
        90,
        100,
        70,
        73,
        91,
        41,
        92,
        89,
        92,
        100,
        0,
        76,
        60,
        100,
        12,
        60,
        76,
        30,
        90,
        84,
        61,
        14,
        60,
        32,
        90,
        72,
        100
    ],
    "21": [
        38,
        30,
        67,
        47,
        100,
        90,
        50,
        20,
        100,
        80,
        60,
        85,
        98,
        95,
        80,
        75,
        100,
        100,
        35,
        42,
        20,
        5,
        63,
        72,
        40,
        65,
        72,
        30,
        64,
        65,
        96,
        85,
        100,
        0,
        90,
        33,
        15,
        90,
        50,
        72,
        50,
        20,
        81,
        75,
        100,
        100,
        100,
        74,
        20,
        100,
        100,
        78,
        75,
        75,
        12,
        45,
        45,
        29,
        90,
        47,
        85,
        74,
        0
    ],
    "22": [
        63,
        20,
        75,
        59,
        75,
        76,
        50,
        90,
        80,
        15,
        50,
        45,
        85,
        77,
        83,
        100,
        100,
        50,
        35,
        41,
        50,
        95,
        42,
        0,
        52,
        35,
        63,
        80,
        64,
        50,
        67,
        65,
        100,
        95,
        76,
        24,
        15,
        82,
        60,
        52,
        36,
        67,
        60,
        81,
        67,
        44,
        100,
        30,
        60,
        14,
        0,
        20,
        11,
        80,
        27,
        79,
        60,
        63,
        75,
        60,
        66,
        40,
        0
    ],
    "23": [
        71,
        61,
        100,
        90,
        95,
        92,
        50,
        53,
        81,
        90,
        70,
        84,
        100,
        85,
        75,
        100,
        100,
        46,
        100,
        58,
        50,
        10,
        67,
        100,
        58,
        65,
        81,
        50,
        100,
        65,
        82,
        85,
        100,
        75,
        92,
        70,
        50,
        79,
        65,
        71,
        81,
        90,
        55,
        65,
        100,
        71,
        100,
        70,
        75,
        50,
        92,
        89,
        77,
        93,
        66,
        100,
        72,
        63,
        100,
        66,
        75,
        50,
        100
    ],
    "24": [
        30,
        20,
        82,
        40,
        20,
        50,
        79,
        16,
        50,
        75,
        61,
        55,
        0,
        5,
        13,
        0,
        18,
        50,
        26,
        41,
        90,
        5,
        88,
        36,
        41,
        35,
        71,
        60,
        38,
        60,
        67,
        29,
        100,
        15,
        50,
        75,
        80,
        20,
        41,
        66,
        72,
        49,
        70,
        20,
        16,
        60,
        0,
        28,
        20,
        86,
        82,
        20,
        20,
        15,
        38,
        18,
        45,
        31,
        10,
        23,
        66,
        20,
        0
    ],
    "25": [
        37,
        20,
        22,
        38,
        0,
        0,
        66,
        0,
        28,
        15,
        3,
        15,
        0,
        10,
        0,
        0,
        9,
        0,
        0,
        40,
        25,
        0,
        33,
        0,
        36,
        15,
        2,
        0,
        0,
        15,
        21,
        5,
        0,
        5,
        0,
        0,
        0,
        11,
        10,
        11,
        21,
        15,
        16,
        20,
        0,
        27,
        0,
        11,
        20,
        0,
        0,
        16,
        16,
        3,
        39,
        18,
        8,
        34,
        23,
        25,
        25,
        0,
        1
    ],
    "26": [
        39,
        20,
        0,
        39,
        0,
        0,
        33,
        0,
        28,
        10,
        14,
        20,
        0,
        0,
        0,
        75,
        0,
        0,
        0,
        26,
        50,
        0,
        45,
        0,
        38,
        10,
        0,
        30,
        0,
        15,
        8,
        5,
        0,
        5,
        0,
        0,
        0,
        0,
        10,
        4,
        20,
        12,
        28,
        5,
        0,
        33,
        0,
        5,
        10,
        0,
        0,
        0,
        12,
        10,
        27,
        18,
        7,
        32,
        5,
        20,
        5,
        15,
        0
    ],
    "27": [
        35,
        20,
        12,
        70,
        15,
        4,
        77,
        63,
        50,
        30,
        31,
        39,
        0,
        0,
        19,
        55,
        18,
        66,
        25,
        56,
        25,
        25,
        36,
        61,
        45,
        35,
        18,
        55,
        56,
        55,
        21,
        39,
        100,
        60,
        4,
        66,
        0,
        10,
        50,
        33,
        22,
        20,
        18,
        25,
        39,
        67,
        100,
        35,
        30,
        0,
        87,
        60,
        14,
        27,
        68,
        16,
        39,
        61,
        55,
        36,
        40,
        30,
        0
    ],
    "28": [
        29,
        20,
        31,
        60,
        10,
        4,
        68,
        75,
        42,
        30,
        20,
        25,
        0,
        5,
        14,
        5,
        0,
        0,
        0,
        39,
        15,
        59,
        59,
        0,
        20,
        35,
        0,
        60,
        0,
        5,
        4,
        35,
        0,
        10,
        4,
        72,
        100,
        0,
        35,
        29,
        75,
        79,
        35,
        20,
        0,
        29,
        100,
        7,
        25,
        0,
        0,
        18,
        0,
        31,
        31,
        20,
        26,
        35,
        30,
        25,
        5,
        20,
        0
    ],
    "29": [
        34,
        20,
        24,
        42,
        25,
        70,
        91,
        15,
        56,
        65,
        30,
        34,
        0,
        5,
        0,
        70,
        20,
        0,
        1,
        37,
        60,
        10,
        67,
        0,
        69,
        25,
        9,
        55,
        42,
        25,
        67,
        25,
        0,
        60,
        70,
        17,
        0,
        0,
        30,
        48,
        28,
        18,
        15,
        55,
        39,
        64,
        0,
        71,
        30,
        0,
        94,
        66,
        19,
        20,
        60,
        53,
        60,
        66,
        20,
        29,
        20,
        10,
        0
    ],
    "30": [
        30,
        10,
        17,
        32,
        0,
        13,
        25,
        3,
        41,
        35,
        30,
        40,
        0,
        0,
        30,
        5,
        21,
        49,
        0,
        40,
        15,
        0,
        41,
        100,
        50,
        35,
        8,
        30,
        0,
        55,
        21,
        55,
        0,
        5,
        13,
        20,
        0,
        20,
        35,
        30,
        19,
        27,
        36,
        30,
        0,
        33,
        0,
        80,
        15,
        87,
        39,
        56,
        72,
        14,
        58,
        13,
        38,
        55,
        10,
        36,
        20,
        50,
        0
    ],
    "31": [
        32,
        30,
        73,
        39,
        0,
        41,
        34,
        50,
        50,
        74,
        73,
        40,
        100,
        0,
        18,
        25,
        60,
        44,
        36,
        25,
        50,
        0,
        76,
        40,
        65,
        40,
        6,
        30,
        26,
        35,
        61,
        55,
        100,
        60,
        41,
        0,
        35,
        11,
        33,
        76,
        28,
        68,
        55,
        55,
        0,
        62,
        100,
        87,
        30,
        0,
        0,
        25,
        21,
        30,
        64,
        67,
        20,
        66,
        10,
        35,
        10,
        50,
        0
    ],
    "32": [
        38,
        4,
        20,
        57,
        0,
        12,
        16,
        14,
        56,
        30,
        26,
        25,
        0,
        5,
        18,
        9,
        15,
        31,
        73,
        58,
        0,
        15,
        29,
        0,
        64,
        60,
        15,
        65,
        65,
        30,
        0,
        34,
        0,
        15,
        12,
        0,
        0,
        0,
        4,
        30,
        69,
        20,
        15,
        55,
        27,
        37,
        0,
        2,
        10,
        0,
        0,
        14,
        29,
        18,
        42,
        28,
        16,
        71,
        0,
        41,
        15,
        30,
        0
    ],
    "33": [
        69,
        20,
        50,
        60,
        0,
        63,
        70,
        50,
        50,
        20,
        70,
        23,
        100,
        0,
        12,
        25,
        14,
        64,
        72,
        38,
        0,
        30,
        65,
        24,
        70,
        10,
        14,
        40,
        21,
        25,
        0,
        25,
        0,
        40,
        63,
        70,
        0,
        0,
        76,
        56,
        0,
        39,
        70,
        35,
        12,
        100,
        100,
        42,
        20,
        0,
        0,
        15,
        28,
        30,
        37,
        100,
        43,
        55,
        40,
        20,
        2,
        66,
        0
    ],
    "34": [
        55,
        20,
        21,
        42,
        60,
        21,
        34,
        50,
        36,
        25,
        64,
        40,
        100,
        0,
        20,
        33,
        78,
        26,
        44,
        39,
        60,
        65,
        23,
        100,
        72,
        5,
        65,
        30,
        27,
        55,
        72,
        65,
        100,
        95,
        21,
        28,
        50,
        0,
        50,
        62,
        21,
        53,
        60,
        65,
        67,
        72,
        0,
        35,
        20,
        30,
        17,
        18,
        14,
        8,
        38,
        100,
        60,
        35,
        25,
        25,
        7,
        32,
        0
    ],
    "35": [
        60,
        10,
        10,
        50,
        10,
        66,
        66,
        71,
        38,
        70,
        40,
        66,
        0,
        60,
        65,
        55,
        80,
        60,
        41,
        45,
        60,
        5,
        69,
        100,
        63,
        65,
        8,
        30,
        72,
        65,
        69,
        65,
        100,
        95,
        66,
        86,
        65,
        70,
        59,
        44,
        15,
        35,
        40,
        65,
        68,
        77,
        0,
        30,
        20,
        100,
        56,
        21,
        80,
        18,
        35,
        48,
        61,
        53,
        90,
        60,
        95,
        70,
        100
    ],
    "36": [
        41,
        11,
        60,
        38,
        10,
        0,
        73,
        0,
        36,
        25,
        30,
        60,
        100,
        15,
        0,
        50,
        0,
        36,
        82,
        33,
        25,
        65,
        32,
        0,
        15,
        55,
        16,
        55,
        21,
        35,
        25,
        35,
        0,
        5,
        0,
        84,
        80,
        21,
        30,
        21,
        27,
        62,
        36,
        30,
        18,
        28,
        0,
        30,
        30,
        69,
        16,
        33,
        5,
        20,
        23,
        0,
        40,
        16,
        0,
        25,
        3,
        15,
        0
    ],
    "37": [
        42,
        15,
        8,
        65,
        60,
        41,
        15,
        74,
        20,
        20,
        58,
        0,
        0,
        25,
        18,
        20,
        0,
        0,
        29,
        43,
        50,
        90,
        62,
        64,
        50,
        30,
        69,
        40,
        15,
        55,
        7,
        60,
        100,
        75,
        41,
        16,
        0,
        15,
        50,
        58,
        30,
        17,
        10,
        15,
        59,
        66,
        0,
        74,
        35,
        78,
        20,
        20,
        39,
        70,
        60,
        27,
        58,
        36,
        30,
        33,
        10,
        50,
        0
    ],
    "38": [
        37,
        5,
        74,
        29,
        5,
        50,
        11,
        30,
        67,
        30,
        56,
        18,
        0,
        5,
        37,
        30,
        24,
        40,
        76,
        55,
        15,
        100,
        57,
        23,
        58,
        55,
        10,
        60,
        36,
        40,
        79,
        45,
        100,
        95,
        50,
        19,
        75,
        24,
        59,
        52,
        21,
        36,
        20,
        65,
        37,
        66,
        0,
        22,
        20,
        0,
        13,
        69,
        16,
        76,
        56,
        85,
        60,
        62,
        60,
        21,
        5,
        69,
        1
    ],
    "39": [
        67,
        26,
        20,
        56,
        81,
        72,
        67,
        76,
        69,
        35,
        100,
        52,
        100,
        80,
        35,
        10,
        79,
        100,
        70,
        79,
        100,
        100,
        55,
        40,
        43,
        70,
        76,
        65,
        67,
        90,
        73,
        45,
        100,
        70,
        72,
        70,
        0,
        76,
        50,
        100,
        100,
        24,
        60,
        75,
        58,
        87,
        100,
        38,
        90,
        100,
        73,
        40,
        100,
        67,
        66,
        70,
        90,
        92,
        80,
        70,
        90,
        47,
        100
    ],
    "40": [
        40,
        60,
        30,
        86,
        90,
        85,
        83,
        12,
        27,
        19,
        16,
        40,
        0,
        70,
        72,
        100,
        100,
        100,
        15,
        65,
        50,
        85,
        68,
        19,
        50,
        25,
        33,
        40,
        79,
        50,
        100,
        85,
        100,
        15,
        85,
        100,
        100,
        0,
        50,
        7,
        25,
        88,
        27,
        85,
        22,
        100,
        100,
        50,
        80,
        100,
        84,
        90,
        100,
        74,
        37,
        100,
        65,
        86,
        70,
        40,
        10,
        36,
        0
    ],
    "41": [
        70,
        20,
        79,
        77,
        80,
        88,
        30,
        67,
        80,
        81,
        83,
        30,
        100,
        70,
        0,
        22,
        0,
        0,
        79,
        62,
        30,
        85,
        60,
        100,
        43,
        75,
        56,
        70,
        37,
        0,
        34,
        55,
        100,
        20,
        88,
        39,
        100,
        0,
        44,
        89,
        67,
        87,
        34,
        35,
        66,
        74,
        0,
        28,
        81,
        100,
        82,
        30,
        74,
        24,
        35,
        16,
        70,
        28,
        20,
        70,
        70,
        64,
        8
    ],
    "42": [
        45,
        90,
        3,
        86,
        3,
        35,
        11,
        0,
        32,
        30,
        2,
        21,
        0,
        1,
        35,
        10,
        0,
        0,
        14,
        42,
        20,
        70,
        65,
        26,
        40,
        5,
        30,
        20,
        37,
        20,
        6,
        64,
        0,
        35,
        35,
        63,
        0,
        10,
        50,
        22,
        39,
        41,
        25,
        25,
        32,
        41,
        0,
        22,
        70,
        0,
        0,
        68,
        0,
        24,
        35,
        70,
        41,
        14,
        15,
        40,
        7,
        45,
        100
    ],
    "43": [
        47,
        10,
        84,
        66,
        2,
        14,
        20,
        0,
        9,
        25,
        0,
        40,
        0,
        3,
        0,
        0,
        75,
        35,
        33,
        65,
        30,
        5,
        71,
        0,
        40,
        60,
        29,
        45,
        0,
        15,
        16,
        30,
        0,
        10,
        14,
        60,
        0,
        15,
        40,
        0,
        38,
        77,
        13,
        15,
        38,
        36,
        0,
        12,
        20,
        0,
        27,
        10,
        0,
        11,
        26,
        36,
        12,
        25,
        0,
        41,
        9,
        14,
        0
    ],
    "44": [
        46,
        25,
        79,
        80,
        2,
        21,
        11,
        100,
        10,
        20,
        76,
        35,
        77,
        15,
        74,
        15,
        100,
        69,
        79,
        64,
        60,
        20,
        69,
        100,
        41,
        85,
        58,
        60,
        42,
        50,
        80,
        20,
        100,
        65,
        21,
        100,
        0,
        21,
        50,
        69,
        34,
        76,
        38,
        25,
        46,
        75,
        0,
        19,
        50,
        0,
        63,
        74,
        72,
        80,
        60,
        74,
        31,
        60,
        10,
        66,
        55,
        15,
        0
    ],
    "45": [
        48,
        20,
        88,
        61,
        9,
        28,
        18,
        9,
        53,
        25,
        24,
        50,
        0,
        15,
        10,
        5,
        70,
        30,
        37,
        60,
        75,
        68,
        58,
        72,
        57,
        35,
        38,
        65,
        26,
        55,
        7,
        24,
        0,
        20,
        28,
        37,
        0,
        10,
        34,
        5,
        35,
        33,
        31,
        30,
        19,
        50,
        0,
        85,
        15,
        0,
        39,
        82,
        31,
        71,
        42,
        0,
        57,
        29,
        50,
        20,
        25,
        40,
        0
    ],
    "46": [
        46,
        10,
        28,
        65,
        20,
        17,
        17,
        70,
        64,
        20,
        44,
        39,
        0,
        16,
        0,
        0,
        100,
        30,
        15,
        39,
        60,
        70,
        46,
        100,
        53,
        40,
        40,
        60,
        39,
        68,
        82,
        7,
        100,
        30,
        17,
        16,
        0,
        20,
        40,
        14,
        40,
        34,
        26,
        35,
        5,
        36,
        0,
        90,
        35,
        100,
        43,
        36,
        64,
        20,
        37,
        15,
        31,
        33,
        0,
        24,
        3,
        29,
        2
    ],
    "47": [
        50,
        5,
        12,
        25,
        5,
        61,
        74,
        100,
        34,
        20,
        15,
        50,
        0,
        0,
        30,
        0,
        100,
        0,
        92,
        62,
        0,
        0,
        75,
        0,
        10,
        75,
        40,
        50,
        50,
        50,
        18,
        45,
        0,
        75,
        61,
        36,
        85,
        10,
        40,
        0,
        19,
        14,
        54,
        15,
        36,
        50,
        0,
        6,
        10,
        0,
        0,
        6,
        50,
        65,
        33,
        37,
        62,
        23,
        30,
        79,
        65,
        0,
        100
    ],
    "48": [
        44,
        40,
        78,
        19,
        40,
        20,
        76,
        0,
        72,
        10,
        72,
        55,
        100,
        0,
        0,
        15,
        23,
        0,
        83,
        39,
        70,
        100,
        54,
        100,
        32,
        35,
        53,
        25,
        71,
        55,
        60,
        40,
        100,
        5,
        20,
        0,
        50,
        15,
        50,
        66,
        12,
        7,
        22,
        25,
        13,
        70,
        0,
        50,
        70,
        100,
        36,
        17,
        10,
        33,
        30,
        71,
        21,
        80,
        15,
        20,
        10,
        0,
        0
    ],
    "49": [
        48,
        60,
        8,
        14,
        70,
        30,
        83,
        73,
        64,
        73,
        23,
        36,
        0,
        5,
        30,
        55,
        10,
        0,
        25,
        37,
        50,
        70,
        57,
        33,
        50,
        40,
        40,
        0,
        60,
        35,
        40,
        58,
        100,
        15,
        30,
        0,
        50,
        14,
        50,
        0,
        67,
        69,
        35,
        50,
        48,
        33,
        0,
        50,
        50,
        100,
        0,
        16,
        30,
        18,
        65,
        20,
        23,
        60,
        15,
        30,
        10,
        30,
        0
    ],
    "50": [
        36,
        30,
        52,
        35,
        20,
        65,
        100,
        0,
        80,
        100,
        42,
        55,
        0,
        0,
        0,
        0,
        100,
        72,
        81,
        64,
        20,
        100,
        60,
        86,
        45,
        40,
        36,
        60,
        76,
        30,
        83,
        66,
        0,
        70,
        65,
        100,
        50,
        20,
        50,
        30,
        87,
        40,
        50,
        30,
        60,
        50,
        100,
        76,
        15,
        0,
        54,
        30,
        32,
        20,
        0,
        0,
        59,
        82,
        53,
        63,
        60,
        26,
        100
    ],
    "51": [
        69,
        20,
        66,
        16,
        25,
        74,
        100,
        0,
        78,
        100,
        65,
        55,
        0,
        0,
        0,
        66,
        80,
        73,
        85,
        28,
        70,
        20,
        83,
        100,
        52,
        60,
        31,
        50,
        50,
        65,
        69,
        55,
        100,
        40,
        74,
        28,
        50,
        20,
        50,
        59,
        26,
        41,
        24,
        60,
        81,
        73,
        100,
        72,
        15,
        0,
        54,
        55,
        66,
        60,
        67,
        62,
        34,
        82,
        50,
        64,
        93,
        62,
        0
    ],
    "52": [
        64,
        10,
        54,
        21,
        10,
        29,
        66,
        26,
        59,
        100,
        25,
        56,
        100,
        0,
        0,
        33,
        100,
        70,
        85,
        44,
        50,
        80,
        56,
        73,
        41,
        70,
        32,
        60,
        65,
        70,
        36,
        40,
        100,
        70,
        29,
        67,
        50,
        21,
        50,
        32,
        68,
        68,
        59,
        30,
        50,
        50,
        0,
        42,
        40,
        0,
        55,
        33,
        19,
        32,
        45,
        61,
        45,
        72,
        50,
        68,
        95,
        50,
        0
    ],
    "53": [
        50,
        2,
        30,
        6,
        25,
        34,
        29,
        11,
        31,
        100,
        31,
        54,
        0,
        0,
        0,
        39,
        76,
        69,
        27,
        43,
        50,
        0,
        71,
        82,
        50,
        40,
        32,
        55,
        67,
        35,
        30,
        50,
        0,
        40,
        34,
        0,
        50,
        15,
        50,
        34,
        0,
        42,
        7,
        40,
        37,
        50,
        100,
        30,
        40,
        0,
        56,
        61,
        42,
        17,
        24,
        23,
        56,
        33,
        46,
        30,
        30,
        35,
        0
    ],
    "54": [
        50,
        20,
        59,
        8,
        10,
        5,
        75,
        0,
        5,
        0,
        25,
        40,
        0,
        0,
        0,
        0,
        0,
        27,
        27,
        62,
        30,
        0,
        46,
        0,
        10,
        30,
        30,
        60,
        79,
        50,
        18,
        20,
        0,
        10,
        5,
        0,
        50,
        15,
        30,
        21,
        0,
        32,
        24,
        10,
        6,
        50,
        0,
        30,
        15,
        0,
        57,
        14,
        22,
        12,
        74,
        20,
        35,
        26,
        0,
        20,
        5,
        15,
        0
    ],
    "55": [
        33,
        60,
        16,
        12,
        5,
        2,
        79,
        26,
        37,
        0,
        58,
        35,
        100,
        0,
        0,
        0,
        20,
        12,
        29,
        39,
        15,
        0,
        70,
        0,
        17,
        15,
        31,
        70,
        90,
        10,
        18,
        42,
        0,
        15,
        2,
        58,
        50,
        10,
        15,
        54,
        0,
        32,
        52,
        45,
        0,
        50,
        0,
        23,
        20,
        0,
        58,
        11,
        0,
        26,
        44,
        66,
        42,
        26,
        10,
        9,
        10,
        40,
        0
    ],
    "56": [
        20,
        10,
        5,
        4,
        5,
        14,
        84,
        25,
        1,
        0,
        20,
        25,
        0,
        0,
        0,
        0,
        16,
        40,
        26,
        37,
        10,
        16,
        50,
        0,
        11,
        10,
        11,
        70,
        67,
        15,
        29,
        22,
        0,
        5,
        14,
        0,
        50,
        0,
        15,
        4,
        0,
        14,
        30,
        5,
        0,
        50,
        0,
        10,
        1,
        0,
        36,
        11,
        50,
        15,
        38,
        25,
        28,
        6,
        0,
        9,
        1,
        10,
        0
    ],
    "57": [
        19,
        40,
        0,
        7,
        2,
        0,
        28,
        0,
        11,
        0,
        18,
        16,
        0,
        0,
        0,
        20,
        0,
        0,
        0,
        65,
        15,
        1,
        50,
        0,
        50,
        5,
        20,
        30,
        26,
        0,
        6,
        6,
        0,
        40,
        0,
        0,
        50,
        0,
        7,
        3,
        0,
        11,
        5,
        1,
        0,
        26,
        0,
        5,
        2,
        0,
        35,
        7,
        0,
        5,
        20,
        0,
        3,
        2,
        0,
        5,
        3,
        20,
        0
    ],
    "58": [
        50,
        15,
        20,
        9,
        0,
        21,
        22,
        0,
        11,
        0,
        6,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        62,
        15,
        0,
        50,
        0,
        24,
        5,
        18,
        40,
        0,
        0,
        25,
        5,
        0,
        5,
        21,
        0,
        50,
        0,
        4,
        8,
        0,
        19,
        0,
        1,
        0,
        5,
        0,
        3,
        10,
        0,
        56,
        8,
        0,
        5,
        27,
        0,
        5,
        6,
        0,
        3,
        1,
        59,
        0
    ],
    "59": [
        17,
        5,
        10,
        0,
        1,
        22,
        70,
        0,
        13,
        0,
        40,
        10,
        0,
        0,
        0,
        26,
        0,
        0,
        0,
        39,
        35,
        0,
        31,
        32,
        16,
        5,
        32,
        30,
        28,
        0,
        9,
        4,
        100,
        5,
        22,
        25,
        50,
        0,
        5,
        34,
        0,
        17,
        1,
        5,
        0,
        8,
        0,
        1,
        10,
        0,
        37,
        10,
        0,
        5,
        24,
        23,
        6,
        4,
        0,
        6,
        1,
        10,
        0
    ],
    "60": [
        13,
        10,
        31,
        17,
        0,
        21,
        0,
        0,
        3,
        0,
        7,
        17,
        0,
        0,
        0,
        30,
        0,
        0,
        0,
        37,
        35,
        0,
        31,
        0,
        25,
        15,
        24,
        60,
        18,
        0,
        60,
        6,
        0,
        20,
        21,
        36,
        50,
        0,
        5,
        9,
        0,
        12,
        4,
        10,
        0,
        3,
        0,
        4,
        5,
        0,
        38,
        6,
        0,
        3,
        23,
        2,
        7,
        6,
        0,
        5,
        3,
        57,
        0
    ],
    "61": [
        19,
        0,
        0,
        0,
        0,
        0,
        25,
        0,
        4,
        0,
        0,
        8,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        31,
        25,
        0,
        28,
        16,
        16,
        2,
        15,
        0,
        59,
        0,
        7,
        21,
        0,
        5,
        0,
        0,
        50,
        0,
        5,
        2,
        0,
        11,
        0,
        1,
        0,
        13,
        0,
        1,
        2,
        0,
        38,
        8,
        0,
        5,
        26,
        7,
        8,
        3,
        0,
        3,
        1,
        0,
        0
    ],
    "62": [
        22,
        10,
        48,
        79,
        0,
        0,
        6,
        100,
        26,
        25,
        41,
        32,
        0,
        20,
        0,
        10,
        20,
        36,
        0,
        36,
        50,
        42,
        58,
        0,
        95,
        20,
        61,
        65,
        30,
        10,
        26,
        17,
        0,
        20,
        0,
        0,
        75,
        10,
        50,
        30,
        29,
        24,
        14,
        1,
        0,
        14,
        0,
        21,
        20,
        0,
        55,
        14,
        12,
        6,
        91,
        32,
        26,
        41,
        15,
        20,
        55,
        30,
        0
    ],
    "63": [
        73,
        61,
        77,
        65,
        25,
        31,
        59,
        34,
        61,
        15,
        56,
        51,
        100,
        10,
        0,
        36,
        85,
        59,
        65,
        30,
        60,
        0,
        62,
        87,
        44,
        70,
        49,
        41,
        43,
        35,
        65,
        36,
        100,
        10,
        31,
        64,
        100,
        82,
        50,
        54,
        50,
        68,
        61,
        50,
        65,
        50,
        100,
        22,
        15,
        31,
        40,
        23,
        15,
        63,
        62,
        100,
        32,
        71,
        12,
        66,
        75,
        66,
        89
    ],
    "64": [
        27,
        61,
        62,
        55,
        40,
        67,
        60,
        70,
        68,
        15,
        28,
        60,
        100,
        10,
        22,
        5,
        86,
        50,
        70,
        66,
        40,
        36,
        62,
        25,
        40,
        65,
        57,
        70,
        70,
        25,
        73,
        70,
        100,
        85,
        67,
        71,
        100,
        50,
        50,
        31,
        72,
        66,
        65,
        60,
        66,
        64,
        100,
        62,
        65,
        0,
        57,
        24,
        15,
        66,
        61,
        100,
        64,
        69,
        12,
        66,
        25,
        50,
        0
    ],
    "65": [
        50,
        30,
        50,
        40,
        35,
        45,
        100,
        79,
        37,
        21,
        72,
        10,
        0,
        20,
        5,
        5,
        0,
        21,
        13,
        40,
        30,
        54,
        80,
        17,
        52,
        30,
        35,
        0,
        38,
        15,
        37,
        56,
        100,
        65,
        45,
        0,
        0,
        75,
        70,
        53,
        68,
        36,
        15,
        75,
        0,
        26,
        0,
        11,
        25,
        18,
        0,
        29,
        26,
        0,
        58,
        0,
        73,
        17,
        25,
        31,
        33,
        63,
        100
    ],
    "66": [
        29,
        65,
        36,
        59,
        60,
        62,
        35,
        40,
        52,
        20,
        70,
        45,
        0,
        60,
        73,
        20,
        90,
        34,
        77,
        67,
        70,
        50,
        50,
        64,
        64,
        35,
        57,
        50,
        37,
        50,
        27,
        45,
        0,
        40,
        62,
        0,
        50,
        67,
        75,
        62,
        23,
        38,
        7,
        65,
        75,
        31,
        100,
        71,
        65,
        20,
        0,
        26,
        74,
        60,
        76,
        35,
        90,
        29,
        50,
        50,
        61,
        69,
        0
    ],
    "67": [
        43,
        40,
        21,
        61,
        75,
        74,
        32,
        39,
        53,
        80,
        82,
        35,
        100,
        75,
        16,
        100,
        100,
        16,
        73,
        41,
        50,
        30,
        26,
        79,
        68,
        75,
        76,
        50,
        40,
        50,
        70,
        65,
        100,
        40,
        74,
        65,
        50,
        60,
        60,
        70,
        79,
        33,
        37,
        55,
        82,
        30,
        0,
        75,
        20,
        100,
        0,
        73,
        82,
        70,
        40,
        70,
        60,
        78,
        40,
        65,
        56,
        50,
        0
    ],
    "68": [
        65,
        86,
        67,
        64,
        40,
        89,
        73,
        75,
        50,
        70,
        73,
        55,
        100,
        40,
        28,
        63,
        0,
        44,
        86,
        64,
        50,
        66,
        17,
        81,
        45,
        35,
        49,
        55,
        100,
        80,
        37,
        35,
        100,
        75,
        89,
        77,
        85,
        82,
        50,
        66,
        26,
        69,
        57,
        35,
        73,
        43,
        100,
        33,
        70,
        23,
        0,
        50,
        12,
        75,
        62,
        42,
        61,
        62,
        60,
        40,
        50,
        80,
        1
    ],
    "69": [
        71,
        80,
        36,
        59,
        70,
        75,
        100,
        100,
        72,
        15,
        77,
        60,
        100,
        70,
        34,
        39,
        67,
        72,
        33,
        67,
        80,
        25,
        61,
        73,
        42,
        65,
        78,
        70,
        100,
        55,
        83,
        62,
        100,
        70,
        75,
        100,
        65,
        50,
        50,
        78,
        81,
        66,
        37,
        55,
        66,
        59,
        100,
        12,
        20,
        100,
        73,
        25,
        85,
        71,
        60,
        75,
        71,
        93,
        10,
        65,
        69,
        93,
        0
    ],
    "70": [
        78,
        60,
        63,
        90,
        95,
        95,
        77,
        100,
        60,
        25,
        92,
        88,
        100,
        90,
        100,
        100,
        79,
        97,
        86,
        64,
        75,
        100,
        43,
        92,
        68,
        85,
        64,
        100,
        100,
        80,
        69,
        64,
        100,
        85,
        95,
        47,
        100,
        91,
        86,
        93,
        89,
        72,
        61,
        85,
        100,
        50,
        100,
        91,
        80,
        100,
        0,
        50,
        100,
        86,
        37,
        100,
        74,
        71,
        80,
        75,
        69,
        72,
        100
    ]
};


export const leaderboardData = [
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 85.81
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 85.72
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 85.56
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 83.46
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 83.01
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 82.95
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 82.68
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 82.68
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 81.81
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 81.8
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 81.76
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 81.6
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 81.53
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 81.53
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 80.78
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 80.53
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 80.28
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 80.2
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 80.17
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 80.03
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 79.95
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 79.93
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 79.62
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 78.87
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 78.71
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 78.26
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 77.99
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 77.94
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 77.92
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 77.81
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 77.77
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 77.35
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 77.12
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 76.94
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 76.88
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 76.12
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 76.1
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 75.93
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 75.8
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 75.58
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 75.49
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 75.39
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 75.11
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 74.72
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 74.56
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 74.43
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 74.27
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 73.88
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 73.57
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 72.67
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 72.39
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 72.36
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 72.21
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 71.8
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 71.54
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 71.53
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 70.74
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 69.99
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 67.26
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 67.14
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 66.83
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 61.43
    }
];

export const leaderboardDataBusiness = [
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 88.13
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 84.47
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 79.81
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 79.75
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 78.0
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 77.09
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 76.1
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 75.33
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 75.0
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 74.96
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 74.51
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 74.36
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 74.33
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 73.98
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 72.69
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 72.42
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 71.66
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 70.74
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 68.83
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 68.6
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 68.49
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 66.83
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 66.41
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 65.05
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 64.77
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 64.68
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 63.92
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 63.83
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 63.46
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 61.17
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 60.81
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 59.53
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 59.25
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 58.41
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 57.58
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 56.38
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 55.72
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 54.25
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 53.93
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 53.36
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 50.81
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 49.9
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 49.63
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 48.86
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 48.5
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 48.25
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 48.19
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 47.0
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 46.94
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 42.8
    },
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 42.25
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 40.26
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 39.35
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 38.06
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 36.25
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 36.21
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 31.25
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 29.93
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 17.92
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 0.0
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 0.0
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 0.0
    }
];

export const leaderboardDataCelebrityDeaths = [
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 100.0
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 100.0
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 100.0
    },
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 98.51
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 98.41
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 98.25
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 97.83
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 96.24
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 94.61
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 93.79
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 92.64
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 92.55
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 92.27
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 92.09
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 91.67
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 91.65
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 91.26
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 90.98
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 90.63
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 90.42
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 89.28
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 89.21
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 88.98
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 88.93
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 88.64
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 88.54
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 88.36
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 88.29
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 88.28
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 88.27
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 88.12
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 87.76
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 87.46
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 87.33
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 87.15
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 86.58
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 86.35
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 85.79
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 85.5
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 84.37
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 84.29
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 83.56
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 83.33
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 83.06
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 82.87
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 82.33
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 82.27
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 81.4
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 81.13
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 80.01
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 77.23
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 76.23
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 75.0
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 75.0
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 75.0
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 74.39
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 72.64
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 72.4
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 70.09
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 66.67
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 65.76
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 57.57
    }
];

export const leaderboardDataGeopolitics = [
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 90.74
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 90.02
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 90.0
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 88.7
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 86.71
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 86.28
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 86.16
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 85.61
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 85.49
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 83.72
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 83.67
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 83.64
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 83.45
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 83.42
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 83.2
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 82.91
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 82.67
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 82.22
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 82.2
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 82.1
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 81.91
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 81.04
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 80.88
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 80.8
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 80.61
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 80.41
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 80.34
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 79.97
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 79.9
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 79.89
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 79.66
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 79.6
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 79.41
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 79.36
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 78.92
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 78.6
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 78.07
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 77.59
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 77.56
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 77.48
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 77.46
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 76.43
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 76.43
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 76.29
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 76.11
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 75.18
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 75.15
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 75.02
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 74.03
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 73.2
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 72.92
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 72.72
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 72.45
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 72.17
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 71.84
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 71.44
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 70.84
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 68.48
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 67.55
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 64.7
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 60.0
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 60.0
    }
];

export const leaderboardDataPopularCulture = [
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 83.58
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 83.58
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 81.6
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 81.01
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 80.67
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 80.65
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 80.53
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 80.0
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 79.86
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 79.68
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 79.52
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 79.19
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 78.85
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 78.21
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 77.61
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 77.57
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 76.66
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 76.61
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 76.53
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 75.95
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 75.92
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 75.61
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 74.78
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 74.57
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 74.22
    },
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 74.21
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 74.14
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 73.96
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 73.69
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 73.34
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 73.19
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 73.19
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 72.39
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 72.26
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 71.82
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 71.48
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 71.46
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 71.44
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 70.84
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 70.33
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 69.75
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 69.62
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 69.33
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 69.02
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 68.6
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 68.39
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 68.28
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 67.07
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 66.45
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 66.1
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 65.29
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 64.59
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 63.63
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 62.84
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 61.25
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 60.0
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 56.8
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 56.41
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 50.0
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 48.73
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 46.49
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 44.07
    }
];

export const leaderboardDataSport = [
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 100.0
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 93.42
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 92.4
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 90.81
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 90.03
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 89.81
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 89.73
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 89.31
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 89.25
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 88.91
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 87.81
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 86.94
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 86.79
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 86.58
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 86.3
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 85.96
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 84.77
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 84.62
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 84.6
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 84.28
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 83.87
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 83.38
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 83.33
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 83.14
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 83.12
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 83.11
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 81.8
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 81.39
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 81.39
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 81.38
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 80.75
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 80.7
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 80.49
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 80.45
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 80.29
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 79.69
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 79.23
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 79.03
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 78.55
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 77.92
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 77.75
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 76.72
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 75.92
    },
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 75.63
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 75.02
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 74.61
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 72.35
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 71.96
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 71.5
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 71.49
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 71.13
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 69.89
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 69.83
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 69.42
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 68.42
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 67.28
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 67.08
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 66.67
    },
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 63.42
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 56.61
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 48.79
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 33.66
    }
];

export const leaderboardDataUKPolitics = [
    {
        "id": "Yk751oqQ7yUplHTeWNQ0b84mJ6l2",
        "name": "Karlan Cortese",
        "score": 90.73
    },
    {
        "id": "5I2OYYJ0H4YaZbbN02p4JsECACq1",
        "name": "George Lowe",
        "score": 88.8
    },
    {
        "id": "byCHQ45GOdQGYA7xVuXIksS9Cuo2",
        "name": "Larry Mohan",
        "score": 87.6
    },
    {
        "id": "XjBsTy3ScPcTAPDuY3R0rQggocl1",
        "name": "Daniel Casey",
        "score": 85.82
    },
    {
        "id": "7vJnpHwJR9MyM0nRJQ6CnbSUV7C3",
        "name": "Charlie Mates",
        "score": 85.8
    },
    {
        "id": "DsYhVWUpjagCXjk79kwv4uQFQcK2",
        "name": "Richard Anderson",
        "score": 85.33
    },
    {
        "id": "iXluLvciaxggHvyPkvRkFxDHTjz1",
        "name": "Edward Makin",
        "score": 84.41
    },
    {
        "id": "MPq8rZEN7YRZfSF01L31cNQ7Zjs1",
        "name": "Bolaji O",
        "score": 83.7
    },
    {
        "id": "DZlHlCzb6xgGLwzrmUfjOv1a33t2",
        "name": "Alfie Whillis",
        "score": 83.31
    },
    {
        "id": "XKQHbvrYdoa4CMR3UMkeEUOtDYa2",
        "name": "Adria Aranda Balibrea",
        "score": 83.05
    },
    {
        "id": "SoxVY1kursSNm12FQRUAaUHK1TH2",
        "name": "Tomas VShort",
        "score": 82.62
    },
    {
        "id": "GpielrRtA4fNGRMp1z8kkTEsk6f1",
        "name": "Cameron Crabtree",
        "score": 82.03
    },
    {
        "id": "HKSZAa6kFBPc5W0iuSPOO6qrECj1",
        "name": "Finlay Johnman",
        "score": 82.01
    },
    {
        "id": "Abe28w8a15VMFspqIxTKBZ7mWrQ2",
        "name": "Asim Tambe",
        "score": 81.29
    },
    {
        "id": "Vkla7jQcAmZ6xS0jhd4tGnOIOAT2",
        "name": "Rohan Bapna",
        "score": 81.16
    },
    {
        "id": "hzUhUMArMPRsB8dEMzXZkYXLf5o2",
        "name": "Michael Tutty",
        "score": 80.82
    },
    {
        "id": "PipOhupErIUd4EXbvv5lEMTBZF62",
        "name": "Isobel l",
        "score": 80.8
    },
    {
        "id": "dvUtmCN2ucO8sHHV95JNN9adiCF2",
        "name": "Samuel Brunning",
        "score": 79.62
    },
    {
        "id": "j3kOHaodmkdIHTiiMFGUNAD9uZD2",
        "name": "Max Djemil",
        "score": 79.03
    },
    {
        "id": "yU2lJuRqrJXnK01IyEEFCrwd7cF3",
        "name": "Adnaan Jiwa",
        "score": 78.49
    },
    {
        "id": "l9oOHKWCOTXqDZbb1nxPBdQ7IYB3",
        "name": "Harry Tomkins",
        "score": 78.41
    },
    {
        "id": "KR7TVIagpmX36dxJ03fm1kUAIPE3",
        "name": "Mack Walsh",
        "score": 77.76
    },
    {
        "id": "rKP0Mz3S0GdiO8FRTCFqnUTgxdD2",
        "name": "Anslem Lobo",
        "score": 77.69
    },
    {
        "id": "760DR5EYoHMAgCgPv1bFFJkOLyM2",
        "name": "Erwan Rivault",
        "score": 77.3
    },
    {
        "id": "HFK2usr6XgawGCKdiq3RoYvJDnF3",
        "name": "Gabrielle Machell",
        "score": 77.14
    },
    {
        "id": "QE94oK9a3zX9xIjawUHBBKe46ID3",
        "name": "Charlie Anderson",
        "score": 76.39
    },
    {
        "id": "5QAP8wnbpWMd4Fde8bEAxiRhdI63",
        "name": "James Martin",
        "score": 76.35
    },
    {
        "id": "TSxgE4BLbKMvgHKcI2u6mzY13rB2",
        "name": "Ed Mcnestry",
        "score": 76.27
    },
    {
        "id": "Acs4tLZrDuck0cVsxRdqs3MySrr2",
        "name": "Emily Atherton",
        "score": 76.09
    },
    {
        "id": "EVi1gWi2d1hBbnsOWFJZmqaRUBs1",
        "name": "Hanne Mortazavi",
        "score": 75.96
    },
    {
        "id": "rPuHOVYe1nPeiDSSHwMTJRRkfon1",
        "name": "Mikey G",
        "score": 75.82
    },
    {
        "id": "o7PRyP0JfLPZMckV97g4dMeypp03",
        "name": "Brendan Machell",
        "score": 75.54
    },
    {
        "id": "8Fm6SqAasThu2UFSPYSOh2ACgcA3",
        "name": "Niall Malik",
        "score": 75.52
    },
    {
        "id": "DF8FSYwVgoTGdVDrAzEzQOON6ev2",
        "name": "Madeleine Van Der Hoek",
        "score": 75.18
    },
    {
        "id": "rA5m4nqqDncLI3JYTKyXromZ8Jz2",
        "name": "Ryan Masters",
        "score": 75.09
    },
    {
        "id": "9wYunIQxfLhkqZrIYPz9PJp6O5g1",
        "name": "Graham Palmer",
        "score": 75.08
    },
    {
        "id": "xJwcuYeWSLgbOg6utongRBPy8s03",
        "name": "Husain Gadiwala",
        "score": 75.08
    },
    {
        "id": "kd0Oz58aWnfHpMWbCuUT5zMgCvH3",
        "name": "Louis Stall",
        "score": 74.58
    },
    {
        "id": "kND9A5zVGLMWYUinkSdHx1v3eS53",
        "name": "Josh Scaramanga",
        "score": 74.3
    },
    {
        "id": "7ujgUeEmSRUJ1An7WFvVSLipyay1",
        "name": "Afra Jiwa",
        "score": 73.77
    },
    {
        "id": "TJNLbfdP63dFx3P6GRqRk8JPa1K3",
        "name": "Robert Thorpe",
        "score": 73.71
    },
    {
        "id": "VjWrZoDq6KYTqZGY4LG4Zv3w52E3",
        "name": "Maddy C",
        "score": 73.69
    },
    {
        "id": "0n2keiWoSnelLAQoRprKqIlOAw72",
        "name": "Callum Boyle",
        "score": 73.68
    },
    {
        "id": "jUSAZ1pER0Yxp5G4pjfxOvOQUrH2",
        "name": "Daniel Majd",
        "score": 73.58
    },
    {
        "id": "ejlJEb39QEgMR1tdKf0rOYqSaWl1",
        "name": "Hannah Mcnaboe",
        "score": 72.83
    },
    {
        "id": "BUJRLKGHyrWes2KF8KXAqjChrP83",
        "name": "Christian Heath",
        "score": 72.51
    },
    {
        "id": "UOLLINDsq3VV8Za6lZI5bHrWxOl1",
        "name": "Tom\u00e1s Duarte",
        "score": 72.05
    },
    {
        "id": "6QAZqsUec6XRA4XYvclmTGVL4Bg1",
        "name": "Cat Cooper",
        "score": 71.48
    },
    {
        "id": "wT6zaTJmoGRiWYIjpnFwmmI4a1r2",
        "name": "Kiersa Berg",
        "score": 70.26
    },
    {
        "id": "c4TgneTGQ8WD2El5dRGgb9NpIHR2",
        "name": "Veronika Benesova",
        "score": 70.07
    },
    {
        "id": "nN6I18XfBxQJCVJiHNObt9CEEEu2",
        "name": "Emma Clark",
        "score": 69.97
    },
    {
        "id": "fMfO5eFMJeSXabpuvWBZZT2dOon1",
        "name": "Valerie Ho",
        "score": 67.27
    },
    {
        "id": "5kFjlBp37DU3dL4YoJCCz2uAJNg1",
        "name": "Lois Kent",
        "score": 66.85
    },
    {
        "id": "FirOjWicXtVT03na6xfo9XtwdLv1",
        "name": "Jamie Wright",
        "score": 66.24
    },
    {
        "id": "UXqXDCWiC1N765apBOAiU98Bsuw2",
        "name": "Irfan Khan",
        "score": 65.09
    },
    {
        "id": "dPICJRazi9Y6hgA0ZXrbQvfmKs53",
        "name": "Dilber Mogal",
        "score": 64.9
    },
    {
        "id": "MAag3gLAD5MFDkr4xiN8Pr5sTkm1",
        "name": "Ed Gwilliam",
        "score": 63.16
    },
    {
        "id": "LZfDcvvLbxfjIby3Rcd6DNhiOPI3",
        "name": "Irene G",
        "score": 62.26
    },
    {
        "id": "Bu7e5p2Js6cfZgNxmK3hpmfENaG3",
        "name": "Amirah Jiwa",
        "score": 61.07
    },
    {
        "id": "doCBkJRwgiXllMNMixBgRjugXR43",
        "name": "Natasha Lobo",
        "score": 60.59
    },
    {
        "id": "PLuztKYlXgb4UfBIhBlMXY6fIrJ3",
        "name": "Cees Van Spaendonck",
        "score": 59.22
    },
    {
        "id": "3XKX87mYx3eLIDsf4YQJhzcKSCh2",
        "name": "Erin Machell",
        "score": 57.89
    }
];